import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import * as QRCode from 'qrcode';
import { ApiService } from 'app/shared/api.service';
import { MqttService } from 'app/core/mqtt/mqtt.service';
import { CartService } from 'app/core/cart/cart.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-digital-invitation',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './digital-invitation.component.html',
    styleUrl: './digital-invitation.component.scss',
})
export class DigitalInvitationComponent implements OnInit, OnDestroy, AfterViewInit {
    currentStep: 'select-category' | 'select-package' | 'select-theme' | 'theme-detail' | 'checkout' | 'payment' = 'select-category';
    selectedPackageId: string = '';
    activeCategory: string = 'pernikahan'; // 'pernikahan' | 'acara' | 'kartu-ucapan'

    // Step 3 State
    selectedTheme: any = null;
    currentThemeIdParam: string = '';
    currentPackageIdParam: string = '';
    selectedReligion: string = 'islam'; // 'islam' | 'kristen' | 'katolik' | 'hindu' | 'buddha' | 'general'
    selectedColorScheme: string = 'mistysage'; // 'mistysage' | 'greynoir' | 'emerald' | 'navy' | 'gold'

    // Demo Modal & Smartphone Preview State
    selectedDemoItem: any = null;
    isDemoModalOpen: boolean = false;
    safeDemoUrl: SafeResourceUrl | null = null;
    rawDemoUrl: string = '';
    isDemoIframeLoading: boolean = true;
    demoQrCodeUrl: string = '';
    demoViewMode: 'interactive' | 'iframe' = 'interactive';
    demoVariants: Array<{ id: string; name: string; religion?: string; icon: string; tag: string; url: string; badge?: string; color: string }> = [];

    // Fullscreen Demo Modal State
    isFullscreenDemoOpen: boolean = false;
    fullscreenDemoUrl: SafeResourceUrl | null = null;
    isFullscreenDemoLoading: boolean = true;
    demoModalPosition = { x: 0, y: 0 };
    isDragging: boolean = false;
    dragStartPos = { x: 0, y: 0 };

    // Step 4 Checkout Form & Promo State
    customerName: string = '';
    customerPhone: string = '';
    customerEmail: string = '';
    voucherCode: string = '';
    appliedDiscount: number = 0;
    appliedVoucherCode: string = '';
    voucherSuccessMsg: string = '';
    voucherErrorMsg: string = '';
    agreeTerms: boolean = false;
    formSubmitted: boolean = false;

    // Step 5 Payment State
    bookingCode: string = '';
    selectedPaymentMethod: string = 'qris';
    qrisPaymentChannelId: string = environment.qris_payment_channel_id || '019e86da-b3c4-7256-bbaf-8939633358c5';
    createdOrderData: any = null;
    qrisDataUrl: string = '';
    isCreatingOrder: boolean = false;
    copiedToastMsg: string = '';

    // Payment Timer & Success Modal State
    paymentTimerSeconds: number = 900;
    formattedPaymentTimer: string = '15:00';
    paymentTimerInterval: any = null;
    isPaymentSuccessModalOpen: boolean = false;

    // Addon Selected Map State
    selectedAddonsMap: {
        [id: string]: {
            qty: number;
            unitPrice: number;
            totalPrice: number;
            addonObj: any;
        };
    } = {};

    // Addon Pagination Slider State
    addonPageIndex: number = 0;

    // Addon Quantity Modal State
    isAddonQtyModalOpen: boolean = false;
    activeModalAddon: any = null;
    modalQty: number = 1;

    // Religion Presets List matching backend WeddingController response structure and home page
    religions = [
        {
            id: 'islam',
            name: 'Islam',
            label: 'Islam',
            icon: '🕌',
            ceremony: 'Akad & Walimah',
            namaAcara: 'Akad',
            ucapanPembuka: 'Assalamualaikum Wr. Wb.',
            ucapanPenutup: 'Wassalamualaikum Wr. Wb.',
            surat: 'QS. Ar-Rum Ayat 21',
            artiSurat: 'Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan pasangan-pasangan untukmu dari jenismu sendiri, agar kamu cenderung dan merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan sayang. Sungguh, pada yang demikian itu benar-benar terdapat tanda-tanda (kebesaran Allah) bagi kaum yang berpikir.',
            greeting: 'Assalamualaikum Wr. Wb.'
        },
        {
            id: 'kristen protestan',
            name: 'Kristen Protestan',
            label: 'Kristen Protestan',
            icon: '⛪',
            ceremony: 'Pemberkatan Nikah',
            namaAcara: 'Pemberkatan Pernikahan',
            ucapanPembuka: 'Salam Sejahtera dalam Kasih Kristus',
            ucapanPenutup: 'Tuhan Yesus memberkati',
            surat: 'Korintus (13:13)',
            artiSurat: 'Demikianlah tinggal ketiga hal ini, yaitu iman, pengharapan dan kasih, dan yang paling besar di antaranya ialah kasih.',
            greeting: 'Salam Sejahtera dalam Kasih Kristus'
        },
        {
            id: 'kristen katolik',
            name: 'Kristen Katolik',
            label: 'Katolik',
            icon: '🕊️',
            ceremony: 'Sakramen Pernikahan',
            namaAcara: 'Sakramen Pernikahan',
            ucapanPembuka: 'Salam Sejahtera dalam Kasih Kristus',
            ucapanPenutup: 'Tuhan Yesus memberkati',
            surat: 'Matius (19 : 6)',
            artiSurat: 'Demikianlah mereka bukan lagi dua, melainkan satu. Karena itu, apa yang telah dipersatukan Allah, tidak boleh diceraikan manusia.',
            greeting: 'Salam Sejahtera dalam Kasih Kristus'
        },
        {
            id: 'hindu',
            name: 'Hindu',
            label: 'Hindu',
            icon: '🪔',
            ceremony: 'Upacara Pawiwahan',
            namaAcara: 'Vivaha',
            ucapanPembuka: 'Om Swastiastu',
            ucapanPenutup: 'Om Shanti Shanti Shanti Om',
            surat: 'Artharvaveda : VI. 122.3',
            artiSurat: 'Wahai pasangan suami-isteri, kembangkanlah cinta kasih di dalam dirimu, tekun dan tetaplah berkarma dalam menggapai kebahagiaan. Karena hanya orang yang bersungguh-sungguhlah mendapatkan keberhasilan dalam berkeluarga.',
            greeting: 'Om Swastiastu'
        },
        {
            id: 'buddha',
            name: 'Buddha',
            label: 'Buddha',
            icon: '☸️',
            ceremony: 'Pemberkatan Pernikahan',
            namaAcara: 'Pemberkatan Pernikahan',
            ucapanPembuka: 'Namo Buddhaya',
            ucapanPenutup: 'Namo Buddhaya',
            surat: 'Angutara Nikaya Bab VI.3; Sutta ke 53',
            artiSurat: 'Mereka akan menjadi suami istri yang berlimpah berkah keberuntungan Apabila keduanya memiliki : Keyakinan, kedermawanan, keterampilan, Ucapan saling mencintai satu sama lain dan hidup sesuai dengan Dhamma.',
            greeting: 'Namo Buddhaya'
        },
        {
            id: 'konghucu',
            name: 'Konghucu',
            label: 'Konghucu',
            icon: '⛩️',
            ceremony: 'Upacara Li Yi',
            namaAcara: 'Hunli',
            ucapanPembuka: 'Dengan Penuh Rasa Syukur',
            ucapanPenutup: 'Dengan Penuh Rasa Syukur',
            surat: 'Kitab Mengzi IV.A.27',
            artiSurat: 'Keharmonisan rumah tangga adalah fondasi kebahagiaan, saling menghormati adalah jalan menuju kehidupan yang penuh kedamaian.',
            greeting: 'Dengan Penuh Rasa Syukur'
        }
    ];

    // Color Scheme Options
    colorSchemes = [
        { id: 'mistysage', name: 'Misty Sage', hex: '#596652', bgClass: 'bg-[#596652]', textClass: 'text-[#596652]' },
        { id: 'greynoir', name: 'Grey Noir', hex: '#4D4D4D', bgClass: 'bg-[#4D4D4D]', textClass: 'text-[#4D4D4D]' },
        { id: 'emerald', name: 'Visidea Emerald', hex: '#10B981', bgClass: 'bg-emerald-600', textClass: 'text-emerald-600' },
        { id: 'navy', name: 'Royal Navy', hex: '#202367', bgClass: 'bg-[#202367]', textClass: 'text-[#202367]' },
        { id: 'gold', name: 'Classic Gold', hex: '#D97706', bgClass: 'bg-amber-600', textClass: 'text-amber-600' },
    ];

    // Category-Specific Add-Ons Data
    categoryAddons: { [cat: string]: any[] } = {
        pernikahan: [
            {
                id: 'wa-blast',
                name: 'Tambah AWH Blast',
                tag: 'Blast',
                desc: 'Kirim link undangan khusus nama tamu otomatis via WhatsApp',
                hasQuantity: true,
                unit: 'Tamu',
                minQty: 50,
                maxQty: 300,
                step: 50,
                defaultQty: 50,
                unitPrice: 200,
                icon: '💬',
            },
            {
                id: 'gallery-foto',
                name: 'Tambah Gallery Foto',
                tag: 'Foto',
                desc: 'Unggah momen kebahagiaan melalui foto terbaik',
                hasQuantity: true,
                unit: 'Foto',
                minQty: 1,
                maxQty: 8,
                step: 1,
                defaultQty: 3,
                unitPrice: 10000,
                icon: '🖼️',
            },
            {
                id: 'dresscode',
                name: 'Dresscode',
                tag: 'Style',
                desc: 'Tentukan pakaian apa yang akan dipakai tamu undangan',
                hasQuantity: false,
                unitPrice: 25000,
                icon: '👔',
            },
            {
                id: 'youtube-prewed',
                name: 'Link Youtube Video Prewedding',
                tag: 'Media',
                desc: 'Bagikan momen pernikahan dengan live streaming / video prewedding',
                hasQuantity: false,
                unitPrice: 25000,
                icon: '🎥',
            },
            {
                id: 'game-undian',
                name: 'Game atau Undian',
                tag: 'Interactive',
                desc: 'Buat keseruan acara dengan pilihan games menarik yang bisa dimainkan bersama',
                hasQuantity: false,
                unitPrice: 50000,
                icon: '🎮',
            },
            {
                id: 'custom-frame-buku',
                name: 'Custom Frame Buku',
                tag: 'Guestbook',
                desc: 'Atur kedatangan tamu dan buat laporan kehadirannya senada undangan',
                hasQuantity: false,
                unitPrice: 200000,
                icon: '📖',
            },
            {
                id: 'custom-frame-photobooth',
                name: 'Custom Frame Photobooth',
                tag: 'Photobooth',
                desc: 'Layanan Photobooth Visidea senada dengan undangan digital',
                hasQuantity: false,
                unitPrice: 200000,
                icon: '📸',
            },
            {
                id: 'video-story',
                name: 'Social Media Video Story',
                tag: 'Story',
                desc: 'Bagikan undangan pernikahan dengan berbagi video story eksklusif',
                hasQuantity: false,
                unitPrice: 225000,
                icon: '🎬',
            },
            {
                id: 'custom-domain',
                name: 'Custom Domain',
                tag: 'Domain',
                desc: 'Buat domain undangan pribadi agar lebih spesial (contoh: anindita-wira.com)',
                hasQuantity: false,
                unitPrice: 400000,
                icon: '🌐',
            },
        ],

        acara: [
            {
                id: 'wa-blast-event',
                name: 'Tambah WA Blast Event',
                tag: 'Blast',
                desc: 'Broadcast pesan undangan otomatis untuk tamu acara ulang tahun, reuni & akikah',
                hasQuantity: true,
                unit: 'Tamu',
                minQty: 50,
                maxQty: 300,
                step: 50,
                defaultQty: 50,
                unitPrice: 200,
                icon: '💬',
            },
            {
                id: 'rundown-event',
                name: 'Rundown & Timeline Event',
                tag: 'Schedule',
                desc: 'Fitur susunan acara & instruksi rundown interaktif untuk tamu',
                hasQuantity: false,
                unitPrice: 30000,
                icon: '🕒',
            },
            {
                id: 'qr-checkin',
                name: 'QR Code Check-in Guestbook',
                tag: 'Checkin',
                desc: 'Sistem absensi tamu via scan QR Code terintegrasi Photobooth Visidea',
                hasQuantity: false,
                unitPrice: 150000,
                icon: '📲',
            },
            {
                id: 'live-stream-slide',
                name: 'Live Photo Stream Slide',
                tag: 'Stream',
                desc: 'Tampilkan slideshow foto acara langsung di layar event',
                hasQuantity: false,
                unitPrice: 100000,
                icon: '📺',
            },
        ],

        'kartu-ucapan': [
            {
                id: 'angpao-qris',
                name: 'Angpao Digital / QRIS',
                tag: 'Cashless',
                desc: 'Fitur penerimaan kado/angpao digital terverifikasi QRIS',
                hasQuantity: false,
                unitPrice: 30000,
                icon: '🧧',
            },
            {
                id: 'voice-note-greeting',
                name: 'Voice Note Greeting',
                tag: 'Audio',
                desc: 'Sematkan rekaman pesan suara personal dari pengirim kartu',
                hasQuantity: false,
                unitPrice: 25000,
                icon: '🎙️',
            },
            {
                id: 'personal-video-story',
                name: 'Personal Video Story',
                tag: 'Video',
                desc: 'Kartu ucapan animasi video eksklusif siap share ke sosial media',
                hasQuantity: false,
                unitPrice: 50000,
                icon: '📹',
            },
        ],
    };

    // Visidea Digital Invitation Pricing Packages (Loaded dynamically from API)
    pricingPackages: any[] = [];

    // Category Filters (Loaded dynamically from API)
    categories: any[] = [];

    // Theme Sub-Category Filter State (Database has 3 for Wedding: Game, Thematic, Cinematic)
    weddingThemeCategoryFilters = [
        { id: 'all', label: 'Semua Tema' },
        { id: 'game', label: 'Game' },
        { id: 'thematic', label: 'Thematic' },
        { id: 'cinematic', label: 'Cinematic' },
    ];

    eventThemeCategoryFilters = [
        { id: 'all', label: 'Semua Tema' },
        { id: 'ulang-tahun', label: 'Ulang Tahun' },
        { id: 'wisuda', label: 'Wisuda' },
        { id: 'grand-opening', label: 'Grand Opening' },
        { id: 'aqiqah', label: 'Aqiqah' },
        { id: 'khitan', label: 'Khitan' },
    ];

    get themeCategoryFilters(): any[] {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            return this.eventThemeCategoryFilters;
        }
        return this.weddingThemeCategoryFilters;
    }

    set themeCategoryFilters(val: any[]) {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            this.eventThemeCategoryFilters = val;
        } else {
            this.weddingThemeCategoryFilters = val;
        }
    }

    activeThemeCategory: string = 'all';

    // Data for Themes (Fetched dynamically from API or static mock)
    allThemes: any[] = [];

    // Cart and Toast feedback
    cartToastMsg: string = '';

    // Invoice State
    isInvoiceModalOpen: boolean = false;
    invoiceData: any = null;

    // Core Features List
    coreFeatures = [
        {
            title: 'Responsive Design',
            desc: 'Tampilan sempurna dan nyaman dibuka di smartphone, tablet, maupun PC desktop.',
            icon: '📱',
        },
        {
            title: 'Custom Nama Tamu Unlimited',
            desc: 'Bagikan link undangan khusus berisikan nama tamu yang dituju secara instan.',
            icon: '💌',
        },
        {
            title: 'RSVP & Buku Tamu Digital',
            desc: 'Konfirmasi kehadiran dan pesan ucapan langsung masuk secara terorganisir.',
            icon: '📅',
        },
        {
            title: 'Navigasi Google Maps',
            desc: 'Memudahkan tamu menuju lokasi acara dengan petunjuk rute yang presisi.',
            icon: '🗺️',
        },
        {
            title: 'Custom Music Backsound',
            desc: 'Pilih lagu kesukaan untuk mengiringi tamu saat membaca undangan digital Anda.',
            icon: '🎵',
        },
        {
            title: 'Amplop Cashless & QRIS',
            desc: 'Fasilitas transfer angpao / kirim kado tanpa ribet dengan fitur keamanan QRIS.',
            icon: '🎁',
        },
        {
            title: 'Galeri Foto & Countdown',
            desc: 'Abadikan momen kebahagiaan dan tampilkan waktu hitung mundur menuju hari-H.',
            icon: '🖼️',
        },
        {
            title: 'Integrasi Visidea Photobooth',
            desc: 'Tersambung langsung dengan sistem QR Code check-in photobooth & guestbook Visidea.',
            icon: '📸',
        },
    ];

    isLoadingPackages: boolean = false;
    isLoadingCategories: boolean = false;
    private mqttSubscription?: Subscription;
    @ViewChild('qrisCanvas') qrisCanvasRef?: ElementRef<HTMLCanvasElement>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApiService,
        private mqttService: MqttService,
        public cartService: CartService,
        private cdr: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
    ) { }

    ngAfterViewInit(): void {
        // Only render if we already have order data (e.g. user navigated back to payment step)
        if (this.createdOrderData?.payment?.qr_code_url) {
            this.renderQrisBarcode();
        }
    }

    ngOnDestroy(): void {
        this.stopPaymentTimer();
        this.stopPaymentStatusPolling();
        if (this.mqttSubscription) {
            this.mqttSubscription.unsubscribe();
        }
    }

    async fetchThemedProductPackages(): Promise<void> {
        this.isLoadingPackages = true;
        try {
            const apiEndpoint = '/api/v1/front/public/themed-product-packages/list?paginate=false&page=&per_page=';
            let response = await this.apiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev API fetch fallback error:', e);
                }
            }

            console.log('Themed Product Packages API Response:', response);

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response)) {
                rawList = response;
            }

            if (rawList && rawList.length > 0) {
                this.pricingPackages = rawList.map((item: any) => {
                    const rawNameKey = String(item.name || item.title || '').toLowerCase().trim();

                    let rawBenefitsList: string[] = [];
                    if (Array.isArray(item.benefits)) {
                        rawBenefitsList = item.benefits.map((b: any) => typeof b === 'string' ? b : (b.name || b.title || b.description || ''));
                    } else if (Array.isArray(item.features)) {
                        rawBenefitsList = item.features.map((f: any) => typeof f === 'string' ? f : (f.name || f.title || f.description || ''));
                    } else if (item.properties && Array.isArray(item.properties.benefit)) {
                        rawBenefitsList = item.properties.benefit.map((b: any) => typeof b === 'string' ? b : (b.name || b.title || ''));
                    } else if (typeof item.description === 'string' && item.description.trim().length > 0) {
                        rawBenefitsList = item.description.split('\n').map((s: string) => s.trim()).filter((b: string) => b.length > 0);
                    }

                    // Pisahkan deskripsi/fitur paket utama dan bonus spesial
                    const isBonusItem = (text: string): boolean => {
                        if (!text) return false;
                        const lower = text.toLowerCase().trim();
                        return lower.startsWith('free') ||
                            lower.startsWith('gratis') ||
                            lower.startsWith('bonus') ||
                            lower.startsWith('hadiah') ||
                            lower.includes('apabila booking') ||
                            lower.includes('jika booking') ||
                            lower.includes('app buku tamu') ||
                            lower === 'app buku tamu';
                    };

                    const benefitsList: string[] = [];
                    let hasBonus = rawNameKey.includes('exclusive');

                    rawBenefitsList.forEach((entry: string) => {
                        if (isBonusItem(entry)) {
                            hasBonus = true;
                        } else {
                            benefitsList.push(entry);
                        }
                    });

                    // Sesuai permintaan pengguna: jika ada bonus isinya hanya "App Buku Tamu", paket lain isinya "-"
                    const bonusText: string = hasBonus ? 'App Buku Tamu' : '-';
                    const bonusesList: string[] = [bonusText];

                    const itemPrice = (item.price !== undefined && item.price !== null) ? Number(item.price) : Number(item.regular_price || 0);

                    return {
                        id: item.id || rawNameKey,
                        rawUuid: item.id,
                        apiPackageKey: rawNameKey,
                        name: item.name || item.title || '',
                        price: itemPrice,
                        badge: item.badge || item.tag || '',
                        popular: Boolean(item.popular || item.is_popular || item.is_featured || rawNameKey.includes('premium')),
                        tagline: item.description || item.short_description || item.tagline || '',
                        benefits: benefitsList,
                        bonus: bonusText,
                        bonuses: bonusesList,
                        showMore: false,
                        rawApiData: item
                    };
                });
            }
        } catch (error) {
            console.error('Error fetching themed product packages from API:', error);
        } finally {
            if (this.currentPackageIdParam) {
                this.selectedPackageId = this.currentPackageIdParam;
            }
            this.isLoadingPackages = false;
            this.cdr.markForCheck();
        }
    }

    isLoadingThemes: boolean = false;

    // Static Mock Themes for Instant Client-Side Presentation
    private staticMockThemes = [
        // GAME & POP CULTURE
        {
            id: 101,
            title: 'Cyberpunk Neon Quest',
            alias: 'cyberpunk',
            category: 'wedding',
            themeCategory: 'game',
            tag: 'Game & Sci-Fi',
            image: '/assets/visidea/theme-1.jpg',
            badge: 'GAME SPECIAL',
            description: 'Tema undangan futuristik bertema cyberpunk & visual novel sci-fi dengan efek neon interaktif.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['8-Bit Pixel Music', 'Quest RSVP Log', 'Interactive Avatar', 'Neon Glowing Accent']
        },
        {
            id: 102,
            title: 'Arcade Pixel Romance 8-Bit',
            alias: 'pixel-romance',
            category: 'wedding',
            themeCategory: 'game',
            tag: 'Retro Arcade',
            image: '/assets/visidea/theme-2.jpg',
            badge: 'POPULAR GAME',
            description: 'Sentuhan nostalgia retro game arcade 8-bit penuh warna dengan mini game interaktif untuk para tamu.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Mini Arcade Game', 'Retro Sound Effect', 'Chiptune Backsound', 'Pixel Art Character']
        },
        {
            id: 103,
            title: 'Fantasy RPG Realm of Love',
            alias: 'rpg-fantasy',
            category: 'wedding',
            themeCategory: 'game',
            tag: 'Fantasy RPG',
            image: '/assets/visidea/theme-3.jpg',
            badge: 'NEW RPG',
            description: 'Konsep petualangan petualang RPG epik seperti Genshin & Zelda menuju hari pernikahan yang sakral.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['World Map Navigation', 'Guild Quest RSVP', 'Cinematic Orchestral', 'Character Stats Sheet']
        },

        // ANIMASI & ANIME
        {
            id: 201,
            title: 'Ghibli Sunset Meadow',
            alias: 'ghibli-sunset',
            category: 'wedding',
            themeCategory: 'animasi',
            tag: 'Animasi & Ghibli',
            image: '/assets/visidea/theme-4.jpg',
            badge: 'AESTHETIC ANIME',
            description: 'Nuansa hangat penuh magis khas film animasi Studio Ghibli dengan ilustrasi bukit hijau & langit senja.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Watercolor Landscape', 'Lofi Anime Music', 'Floating Clouds Effect', 'Cute Chibi Couple']
        },
        {
            id: 202,
            title: 'Chibi Romance Pastel Dream',
            alias: 'chibi-pastel',
            category: 'wedding',
            themeCategory: 'animasi',
            tag: 'Animasi Cute',
            image: '/assets/visidea/theme-5.jpg',
            badge: 'CUTE ANIME',
            description: 'Karakter animasi chibi imut dengan palet warna pastel lembut dan animasi interaktif yang menggemaskan.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Custom Chibi Illustration', 'Cute Sticker RSVP', 'Pastel Blossom Particles', 'Sweet Acoustic Music']
        },
        {
            id: 203,
            title: 'Makoto Starry Sky Dreamscape',
            alias: 'starry-sky',
            category: 'wedding',
            themeCategory: 'animasi',
            tag: 'Anime Romance',
            image: '/assets/visidea/theme-6.jpg',
            badge: 'ROMANTIC ANIME',
            description: 'Terinspirasi karya animasi sinematik Makoto Shinkai dengan langit berbintang dan meteor bercahaya.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Starry Night Sky Motion', 'Piano Melodic BGM', 'Comet Animation', 'Countdown Galaxy']
        },

        // MONOCHROME & MINIMALIST
        {
            id: 301,
            title: 'Noir Minimalist Typography',
            alias: 'noir-minimalist',
            category: 'wedding',
            themeCategory: 'monochrome',
            tag: 'Monochrome Clean',
            image: '/assets/visidea/theme-7.jpg',
            badge: 'TIMELESS MONO',
            description: 'Desain monokrom hitam putih modern abadi dengan tipografi elegan serif dan layout editorial majalah.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Editorial Magazine Layout', 'Black & White Aesthetic', 'Minimalist Serif Font', 'Clean Architecture']
        },
        {
            id: 302,
            title: 'Charcoal & Pure White Slate',
            alias: 'charcoal-white',
            category: 'wedding',
            themeCategory: 'monochrome',
            tag: 'Monochrome Pure',
            image: '/assets/visidea/theme-8.jpg',
            badge: 'MODERN MONO',
            description: 'Kombinasi tegas warna charcoal dan pure white dengan garis simetris yang tegas dan elegan.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['High Contrast Tone', 'Monochrome Gallery', 'Sophisticated Flow', 'Smooth Fade Transition']
        },

        // FLORAL & BOTANICAL
        {
            id: 401,
            title: 'Misty Botanical Sage Garden',
            alias: 'botanical-sage',
            category: 'wedding',
            themeCategory: 'floral',
            tag: 'Floral Botanical',
            image: '/assets/visidea/theme-9.jpg',
            badge: 'BEST FLORAL',
            description: 'Keindahan alam dedaunan eucalyptus dan palet warna sage green yang menyejukkan hati para tamu.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Falling Leaves Effect', 'Watercolor Flora Frame', 'Acoustic Nature BGM', 'Glassmorphism Card']
        },
        {
            id: 402,
            title: 'Blush Rose Gold Petals',
            alias: 'blush-rosegold',
            category: 'wedding',
            themeCategory: 'floral',
            tag: 'Floral Romance',
            image: '/assets/visidea/theme-10.jpg',
            badge: 'SWEET FLORAL',
            description: 'Kelopak bunga mawar mekar dengan sentuhan aksen rose gold lembut yang feminin dan mempesona.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Rose Petal Floating', 'Rose Gold Shimmer', 'Romantic Violin Soundtrack', 'Golden Foil Accent']
        },

        // ADAT TRADISIONAL
        {
            id: 501,
            title: 'Royal Javanese Keraton Heritage',
            alias: 'javanese-keraton',
            category: 'wedding',
            themeCategory: 'adat',
            tag: 'Adat Jawa',
            image: '/assets/visidea/theme-1.jpg',
            badge: 'ADAT JAWA',
            description: 'Ornamen megah ukiran gebyok keraton Jawa klasik dengan sentuhan warna hitam emas ningrat.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Ukiran Keraton Emas', 'Gending Jawa Instrument', 'Gunungan Wayang Frame', 'Aksara & Makna Filosofis']
        },
        {
            id: 502,
            title: 'Minang Luxury Suntiang Emas',
            alias: 'minang-suntiang',
            category: 'wedding',
            themeCategory: 'adat',
            tag: 'Adat Minang',
            image: '/assets/visidea/theme-2.jpg',
            badge: 'ADAT MINANG',
            description: 'Kemegahan ornamen Rumah Gadang dan mahkota suntiang emas Minangkabau yang berkelas tinggi.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Motif Songket Emas', 'Saluang Tradisional Sound', 'Rumah Gadang Ornament', 'Red & Gold Grandeur']
        },

        // LUXURY & GOLD
        {
            id: 601,
            title: 'Sparkling Golden Royal Palace',
            alias: 'golden-royal',
            category: 'wedding',
            themeCategory: 'luxury',
            tag: 'Luxury Gold',
            image: '/assets/visidea/theme-3.jpg',
            badge: 'ROYAL LUXURY',
            description: 'Kemewahan aristokrat dengan sentuhan foil emas berkilau dan marmer putih mewah kelas dunia.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Gold Glitter Particle', 'Marble Stone Texture', 'Grand Orchestra Waltz', 'Royal Wax Seal RSVP']
        },
        {
            id: 602,
            title: 'Emerald Velvet Imperial Gold',
            alias: 'emerald-imperial',
            category: 'wedding',
            themeCategory: 'luxury',
            tag: 'Imperial Luxury',
            image: '/assets/visidea/theme-4.jpg',
            badge: 'EXCLUSIVE GOLD',
            description: 'Perpaduan megah warna emerald green yang dalam dengan ornamen emas murni 24 karat.',
            price: 150000,
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Emerald Velvet Texture', '24K Gold Line Art', 'Deep Imperial Palette', 'Lustrous Glow Effect']
        },

        // MODERN AESTHETIC
        {
            id: 701,
            title: 'Modern Aesthetic Glassmorphism',
            alias: 'modern-glass',
            category: 'wedding',
            themeCategory: 'modern',
            tag: 'Modern Aesthetic',
            image: '/assets/visidea/theme-5.jpg',
            badge: 'TRENDING 2026',
            description: 'Tren UI modern terdepan dengan kartu kaca frosted glass transparan, gradasi lembut, dan animasi smooth.',
            features: ['Frosted Glass Card UI', 'Interactive Music Player', 'Smooth Parallax Effect', 'Countdown & Google Maps']
        },

        // ==========================================
        // EVENT INVITATION CUSTOM THEME (STATIC CARD)
        // ==========================================
        {
            id: 805,
            title: 'Custom Event Invitation',
            alias: 'custom-event-invitation',
            category: 'event',
            themeCategory: 'custom',
            tag: 'Custom Request',
            image: '/assets/visidea/custom-event.png',
            badge: 'CUSTOM EVENT',
            isCustomEvent: true,
            description: 'Pesan tema undangan digital acara khusus dengan konsep, palet warna, dan referensi desain bebas sesuai keinginan Anda.',
            price: 250000,
            demo_url: 'https://wa.me/6282260084847?text=Halo%20Visidea%20Studio,%20saya%20tertarik%20untuk%20request%20Custom%20Event%20Digital%20Invitation.',
            demoUrl: 'https://wa.me/6282260084847?text=Halo%20Visidea%20Studio,%20saya%20tertarik%20untuk%20request%20Custom%20Event%20Digital%20Invitation.',
            suitablePackages: ['lite', 'exclusive', 'premium', 'bundling'],
            features: ['Bebas Tentukan Tema & Konsep', 'Bisa Kirim Referensi Desain', 'Custom Palet Warna & Font', 'Konsultasi Tim Desain Visidea']
        }
    ];

    private cleanText(str?: string | null): string {
        if (!str) return '';
        return String(str).replace(/\[event\]/gi, '').replace(/\[wedding\]/gi, '').trim();
    }

    private isThemeCategoryForEvent(cat: any): boolean {
        if (!cat) return false;
        const catName = String(cat.name || cat.title || cat.label || '').toLowerCase().trim();
        const catSlug = String(cat.slug || cat.id || '').toLowerCase().trim();
        const rawDesc = String(cat.description || '').toLowerCase().trim();
        const catProdName = String(cat.product_category?.name || cat.product_category_name || cat.product_category?.slug || '').toLowerCase().trim();

        // 1. Explicit Event Indicators (Takes highest priority)
        const isEvent =
            catProdName.includes('event') ||
            catProdName.includes('acara') ||
            catName.includes('event') ||
            catName.includes('acara') ||
            catName.includes('grand opening') ||
            catName.includes('opening') ||
            catName.includes('seminar') ||
            catName.includes('birthday') ||
            catName.includes('ulang tahun') ||
            catName.includes('wisuda') ||
            catName.includes('graduation') ||
            catName.includes('konser') ||
            catName.includes('concert') ||
            catName.includes('workshop') ||
            catName.includes('gathering') ||
            catName.includes('corporate') ||
            catName.includes('reuni') ||
            catName.includes('aqiqah') ||
            catName.includes('akikah') ||
            catName.includes('khitan') ||
            catName.includes('sunat') ||
            catName.includes('party') ||
            catSlug.includes('event') ||
            catSlug.includes('opening') ||
            catSlug.includes('birthday') ||
            catSlug.includes('ulang') ||
            catSlug.includes('wisuda') ||
            catSlug.includes('aqiqah') ||
            catSlug.includes('khitan') ||
            rawDesc.includes('[event]');

        if (isEvent) return true;

        // 2. Explicit Wedding Indicators
        const isWedding =
            catProdName.includes('wedding') ||
            catProdName.includes('pernikahan') ||
            catName.includes('wedding') ||
            catName.includes('pernikahan') ||
            catName.includes('nikah') ||
            catName.includes('akad') ||
            catName.includes('bridal') ||
            catName.includes('game') ||
            catName.includes('thematic') ||
            catName.includes('cinematic') ||
            catSlug.includes('game') ||
            catSlug.includes('thematic') ||
            catSlug.includes('cinematic') ||
            catSlug.includes('wedding') ||
            catSlug.includes('pernikahan') ||
            catSlug.includes('nikah') ||
            catSlug === 'modern' ||
            catSlug === 'luxury' ||
            catSlug === 'adat' ||
            catSlug === 'floral' ||
            catSlug === 'monochrome' ||
            catSlug === 'animasi';

        if (isWedding) return false;

        return false;
    }

    async fetchThemeCategories(): Promise<void> {
        try {
            const apiEndpoints = [
                '/api/v1/front/public/theme-categories/list?paginate=false',
                '/api/v1/front/public/theme-categories'
            ];

            let rawList: any[] = [];
            for (const endpoint of apiEndpoints) {
                try {
                    let response = await this.apiService.get(endpoint, false);
                    if (!response || !response.success || !response.data) {
                        try {
                            const devRes = await fetch(`https://dev.api.visideastudio.com${endpoint}`);
                            if (devRes.ok) response = await devRes.json();
                        } catch (e) { }
                    }

                    if (response && response.data) {
                        if (Array.isArray(response.data.list)) rawList = response.data.list;
                        else if (Array.isArray(response.data)) rawList = response.data;
                        else if (Array.isArray(response.data.data)) rawList = response.data.data;
                    } else if (Array.isArray(response)) {
                        rawList = response;
                    }

                    if (rawList && rawList.length > 0) {
                        break;
                    }
                } catch (e) { }
            }

            if (rawList && rawList.length > 0) {
                const weddingList: any[] = [];
                const eventList: any[] = [];

                rawList.forEach((cat: any) => {
                    const cleanLabel = this.cleanText(cat.name || cat.title || cat.label || 'Kategori');
                    const item = {
                        id: String(cat.slug || cat.id || cat.name || '').toLowerCase().trim(),
                        label: cleanLabel
                    };

                    if (!item.id || !item.label) return;

                    if (this.isThemeCategoryForEvent(cat)) {
                        if (!eventList.some(e => e.id === item.id || e.label.toLowerCase() === item.label.toLowerCase())) {
                            eventList.push(item);
                        }
                    } else {
                        if (!weddingList.some(w => w.id === item.id || w.label.toLowerCase() === item.label.toLowerCase())) {
                            weddingList.push(item);
                        }
                    }
                });

                if (weddingList.length > 0) {
                    this.weddingThemeCategoryFilters = [
                        { id: 'all', label: 'Semua Tema' },
                        ...weddingList
                    ];
                }

                if (eventList.length > 0) {
                    this.eventThemeCategoryFilters = [
                        { id: 'all', label: 'Semua Tema' },
                        ...eventList
                    ];
                }
            }
        } catch (error) {
            console.error('Error fetching dynamic theme categories from API:', error);
        }
    }

    private isProductForEvent(item: any): boolean {
        if (!item) return false;
        const rawCatSlug = String(item.product_category_slug || item.product_category?.slug || item.invitation_type?.slug || item.category_slug || item.invitation_theme?.invitation_type_name || '').toLowerCase().trim();
        const rawCatName = String(item.product_category_name || item.product_category?.name || item.invitation_type?.name || item.category_name || item.category || item.type || item.product_type || item.scope || item.invitation_theme?.invitation_type_name || '').toLowerCase().trim();
        const rawInvitationTypeId = String(item.invitation_type_id || item.invitation_type?.id || item.invitation_theme?.invitation_type_id || item.product_category_id || item.category_id || '').toLowerCase().trim();
        const themeNameLower = String(item.name || item.title || '').toLowerCase().trim();
        const themeAliasLower = String(item.alias || item.slug || '').toLowerCase().trim();
        const themeDescLower = String(item.description || '').toLowerCase().trim();
        const themeShortDescLower = String(item.short_description || '').toLowerCase().trim();

        // 1. Explicit Wedding Markers (Takes absolute precedence)
        const isExplicitWedding =
            rawInvitationTypeId === '019f45cb-0c72-70c9-9295-30be2e0a2712' || // Wedding UUID
            themeAliasLower.includes('wedding-of-') ||
            themeAliasLower.includes('wedding') ||
            themeAliasLower.includes('nikah') ||
            themeNameLower.includes('wedding') ||
            themeNameLower.includes('nikah') ||
            themeNameLower.includes('pernikahan') ||
            themeNameLower.includes('akad') ||
            rawCatName.includes('wedding') ||
            rawCatName.includes('pernikahan') ||
            rawCatSlug.includes('wedding') ||
            rawCatSlug.includes('pernikahan') ||
            item.type === 'wedding' ||
            item.product_type === 'wedding';

        if (isExplicitWedding) return false;

        // 2. Check attached theme categories
        if (Array.isArray(item.theme_categories) && item.theme_categories.some((tc: any) => this.isThemeCategoryForEvent(tc))) {
            return true;
        }

        // 3. Explicit Event Markers
        const isExplicitEvent =
            rawInvitationTypeId === '01a079ed-d640-72fc-9792-62abe018a8b3' || // Event UUID
            rawCatSlug.includes('event') || rawCatSlug.includes('acara') || rawCatSlug.includes('guest') ||
            rawCatName.includes('event') || rawCatName.includes('acara') || rawCatName.includes('guest') ||
            item.type === 'event' || item.product_type === 'event' || item.scope === 'event' ||
            themeNameLower.includes('event') || themeNameLower.includes('acara') || themeNameLower.includes('grand opening') ||
            themeNameLower.includes('wisuda') || themeNameLower.includes('graduation') || themeNameLower.includes('birthday') ||
            themeNameLower.includes('ulang tahun') || themeNameLower.includes('seminar') || themeNameLower.includes('konser') ||
            themeNameLower.includes('concert') || themeNameLower.includes('workshop') || themeNameLower.includes('gathering') ||
            themeNameLower.includes('corporate') || themeNameLower.includes('aqiqah') || themeNameLower.includes('khitan') ||
            themeAliasLower.includes('event') || themeAliasLower.includes('acara') || themeAliasLower.includes('wisuda') ||
            themeAliasLower.includes('birthday') || themeAliasLower.includes('seminar') || themeAliasLower.includes('concert') ||
            themeAliasLower.includes('grand-opening') ||
            themeDescLower.includes('[event]') || themeShortDescLower.includes('[event]');

        return isExplicitEvent;
    }

    private mapThemedProductItem(item: any, index: number = 0): any {
        const packagesList: string[] = [];
        if (Array.isArray(item.packages)) {
            item.packages.forEach((pkg: any) => {
                if (typeof pkg === 'string') packagesList.push(pkg.toLowerCase().trim());
                else if (pkg && typeof pkg === 'object') {
                    if (pkg.id) packagesList.push(String(pkg.id).toLowerCase().trim());
                    if (pkg.name) packagesList.push(String(pkg.name).toLowerCase().trim());
                }
            });
        }

        const isEvent = this.isProductForEvent(item);
        const finalCategory = isEvent ? 'event' : 'wedding';
        const themeNameLower = String(item.name || item.title || '').toLowerCase();

        let inferredThemeCat = 'modern';
        if (item.theme_categories && item.theme_categories.length > 0) {
            const firstTc = item.theme_categories[0];
            inferredThemeCat = String(firstTc.slug || firstTc.id || firstTc.name || '').toLowerCase().trim();
        } else if (themeNameLower.includes('ulang') || themeNameLower.includes('birthday') || themeNameLower.includes('sweet')) {
            inferredThemeCat = 'ulang-tahun';
        } else if (themeNameLower.includes('wisuda') || themeNameLower.includes('graduation')) {
            inferredThemeCat = 'wisuda';
        } else if (themeNameLower.includes('opening') || themeNameLower.includes('peresmian')) {
            inferredThemeCat = 'grand-opening';
        } else if (themeNameLower.includes('aqiqah') || themeNameLower.includes('akikah')) {
            inferredThemeCat = 'aqiqah';
        } else if (themeNameLower.includes('khitan') || themeNameLower.includes('sunat')) {
            inferredThemeCat = 'khitan';
        } else if (themeNameLower.includes('game') || themeNameLower.includes('pixel') || themeNameLower.includes('cyber') || themeNameLower.includes('rpg')) {
            inferredThemeCat = 'game';
        } else if (themeNameLower.includes('animasi') || themeNameLower.includes('anime') || themeNameLower.includes('chibi') || themeNameLower.includes('ghibli')) {
            inferredThemeCat = 'animasi';
        } else if (themeNameLower.includes('monochrome') || themeNameLower.includes('noir') || themeNameLower.includes('black') || themeNameLower.includes('charcoal')) {
            inferredThemeCat = 'monochrome';
        } else if (themeNameLower.includes('floral') || themeNameLower.includes('botanical') || themeNameLower.includes('rose') || themeNameLower.includes('sage') || themeNameLower.includes('flower')) {
            inferredThemeCat = 'floral';
        } else if (themeNameLower.includes('adat') || themeNameLower.includes('jawa') || themeNameLower.includes('sunda') || themeNameLower.includes('minang') || themeNameLower.includes('batak')) {
            inferredThemeCat = 'adat';
        } else if (themeNameLower.includes('gold') || themeNameLower.includes('luxury') || themeNameLower.includes('royal') || themeNameLower.includes('emerald') || themeNameLower.includes('diamond')) {
            inferredThemeCat = 'luxury';
        }

        const themeTag = (item.theme_categories && item.theme_categories.length > 0)
            ? item.theme_categories.map((tc: any) => this.cleanText(tc.name || tc.title)).filter(Boolean).join(' • ')
            : (item.alias || item.short_description || item.tag || '');

        const themeBadge = (item.theme_categories && item.theme_categories[0]?.name)
            ? this.cleanText(item.theme_categories[0].name).toUpperCase()
            : (item.badge || item.tag || (finalCategory === 'event' ? 'EVENT THEME' : 'VISIDEA THEME'));

        let coverImg = item.cover_image_url || item.background_image_url || item.image_url || item.image || item.cover;
        let secondImg = item.hover_image_url || item.secondary_image_url || item.image_2 || item.image2 || item.hover_image || item.second_image;

        if (Array.isArray(item.images) && item.images.length > 0) {
            const validImgs = item.images.map((img: any) => typeof img === 'string' ? img : (img?.url || img?.image_url || img?.src)).filter(Boolean);
            if (!coverImg && validImgs.length > 0) coverImg = validImgs[0];
            if (!secondImg && validImgs.length > 1) secondImg = validImgs[1];
        }
        if (Array.isArray(item.gallery) && item.gallery.length > 0) {
            const validGallery = item.gallery.map((img: any) => typeof img === 'string' ? img : (img?.url || img?.image_url || img?.src)).filter(Boolean);
            if (!secondImg && validGallery.length > 0) secondImg = validGallery[0];
        }
        if (Array.isArray(item.photos) && item.photos.length > 0) {
            const validPhotos = item.photos.map((img: any) => typeof img === 'string' ? img : (img?.url || img?.image_url || img?.src)).filter(Boolean);
            if (!secondImg && validPhotos.length > 0) secondImg = validPhotos[0];
        }
        if (!coverImg) {
            coverImg = `/assets/visidea/theme-${(index % 10) + 1}.jpg`;
        }

        let rawFeaturesList: string[] = [];
        if (Array.isArray(item.features)) {
            rawFeaturesList = item.features.map((f: any) => typeof f === 'string' ? f : (f.name || f.title || f.description || ''));
        } else if (Array.isArray(item.benefits)) {
            rawFeaturesList = item.benefits.map((b: any) => typeof b === 'string' ? b : (b.name || b.title || b.description || ''));
        } else if (item.properties && Array.isArray(item.properties.features)) {
            rawFeaturesList = item.properties.features.map((f: any) => typeof f === 'string' ? f : (f.name || f.title || ''));
        } else if (typeof item.features === 'string' && item.features.trim().length > 0) {
            rawFeaturesList = item.features.split('\n').map((s: string) => s.trim()).filter(Boolean);
        }

        const themeDescription = this.cleanText(item.description || item.short_description || (finalCategory === 'event' ? 'Undangan digital acara / event spesial dengan fitur interaktif lengkap.' : 'Desain undangan digital premium Visidea Studio siap pakai dengan kustomisasi lengkap.'));
        const themePrice = (item.price !== undefined && item.price !== null) ? Number(item.price) : Number(item.regular_price || 150000);
        const themeDemoUrl = this.cleanAndFormatDemoUrl(
            item.demo_url || item.url || item.preview_url || item.link || item.website_url || item.preview_link || item.slug || item.alias
        );

        return {
            id: item.id || (index + 1),
            rawUuid: item.id,
            title: this.cleanText(item.name || item.title || ''),
            alias: item.alias || item.slug || '',
            category: finalCategory,
            themeCategory: inferredThemeCat,
            themeCategories: item.theme_categories || [],
            tag: themeTag,
            image: coverImg,
            hoverImage: secondImg || null,
            badge: themeBadge,
            description: themeDescription,
            shortDescription: this.cleanText(item.short_description || ''),
            price: themePrice,
            demo_url: themeDemoUrl,
            demoUrl: themeDemoUrl,
            suitablePackages: packagesList.length > 0 ? packagesList : ['lite', 'exclusive', 'premium', 'bundling'],
            features: rawFeaturesList.length > 0 ? rawFeaturesList : ['Responsive Mobile & Desktop', 'Buku Tamu Digital & RSVP', 'Google Maps Navigation', 'Amplop Cashless & QRIS'],
            rawApiData: item
        };
    }

    async fetchThemedProductById(themeId: string): Promise<any> {
        if (!themeId) return null;
        try {
            const apiEndpoint = `/api/v1/front/public/themed-products/${themeId}`;
            let response = await this.apiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) { }
            }

            if (response && response.data) {
                const item = response.data;
                const mapped = this.mapThemedProductItem(item, 0);
                this.selectedTheme = mapped;
                const exists = this.allThemes.some((t) => String(t.id).toLowerCase() === String(item.id).toLowerCase());
                if (!exists) {
                    this.allThemes = [mapped, ...this.allThemes];
                }
                this.cdr.markForCheck();
                return mapped;
            }
        } catch (error) {
            console.error(`Error fetching themed product by id (${themeId}):`, error);
        }
        return null;
    }

    async fetchThemedProducts(): Promise<void> {
        this.isLoadingThemes = true;
        try {
            const apiEndpoint = '/api/v1/front/public/themed-products/list?paginate=false&page=&per_page=';
            let response = await this.apiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev API fetch themed products error:', e);
                }
            }

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response)) {
                rawList = response;
            }

            if (rawList && rawList.length > 0) {
                this.allThemes = rawList.map((item: any, index: number) => this.mapThemedProductItem(item, index));
            } else {
                // Fallback to static mock themes
                this.allThemes = [...this.staticMockThemes];
            }
        } catch (error) {
            console.error('Error fetching themed products from API, fallback to static mock:', error);
            this.allThemes = [...this.staticMockThemes];
        } finally {
            if (!this.allThemes || this.allThemes.length === 0) {
                this.allThemes = [...this.staticMockThemes];
            }

            // If current route specifies a themeId, match and set selectedTheme immediately
            if (this.currentThemeIdParam) {
                const tId = String(this.currentThemeIdParam).toLowerCase().trim();
                const found = this.allThemes.find((t) => String(t.id).toLowerCase() === tId || String(t.rawUuid || '').toLowerCase() === tId);
                if (found) {
                    this.selectedTheme = found;
                } else if (this.currentThemeIdParam.length > 10) {
                    this.fetchThemedProductById(this.currentThemeIdParam);
                }
            }

            this.isLoadingThemes = false;
            this.cdr.markForCheck();
        }
    }

    private setStep(newStep: 'select-category' | 'select-package' | 'select-theme' | 'theme-detail' | 'checkout' | 'payment'): void {
        if (this.currentStep !== newStep) {
            this.currentStep = newStep;
            if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, behavior: 'instant' });
            }
        }
        if (newStep === 'payment') {
            this.startPaymentTimer();
            this.startPaymentStatusPolling();
        } else {
            this.stopPaymentTimer();
            this.stopPaymentStatusPolling();
        }
    }

    startPaymentTimer(): void {
        this.stopPaymentTimer();

        const expiredAtStr =
            this.createdOrderData?.payment?.expired_at ||
            this.createdOrderData?.payment?.expired_time ||
            this.createdOrderData?.payment?.expires_at;

        if (expiredAtStr) {
            const expTime = new Date(expiredAtStr).getTime();
            const nowTime = Date.now();
            const diffSeconds = Math.max(0, Math.floor((expTime - nowTime) / 1000));
            if (diffSeconds > 0) {
                this.paymentTimerSeconds = diffSeconds;
            } else {
                this.paymentTimerSeconds = 900;
            }
        } else {
            this.paymentTimerSeconds = 900;
        }

        this.updateFormattedPaymentTimer();

        this.paymentTimerInterval = setInterval(() => {
            if (this.paymentTimerSeconds > 0) {
                this.paymentTimerSeconds--;
                this.updateFormattedPaymentTimer();
                this.cdr.markForCheck();
            } else {
                this.stopPaymentTimer();
            }
        }, 1000);
    }

    stopPaymentTimer(): void {
        if (this.paymentTimerInterval) {
            clearInterval(this.paymentTimerInterval);
            this.paymentTimerInterval = null;
        }
    }

    updateFormattedPaymentTimer(): void {
        const minutes = Math.floor(this.paymentTimerSeconds / 60);
        const seconds = this.paymentTimerSeconds % 60;
        const mm = minutes.toString().padStart(2, '0');
        const ss = seconds.toString().padStart(2, '0');
        this.formattedPaymentTimer = `${mm}:${ss}`;
    }

    isCheckingPaymentStatus: boolean = false;
    paymentPollingInterval: any = null;

    startPaymentStatusPolling(): void {
        this.stopPaymentStatusPolling();
        this.checkPaymentStatusApi();
        this.paymentPollingInterval = setInterval(() => {
            if (this.isPaymentSuccess()) {
                this.stopPaymentStatusPolling();
                return;
            }
            this.checkPaymentStatusApi();
        }, 4000);
    }

    stopPaymentStatusPolling(): void {
        if (this.paymentPollingInterval) {
            clearInterval(this.paymentPollingInterval);
            this.paymentPollingInterval = null;
        }
    }

    async checkPaymentStatusApi(manual: boolean = false): Promise<void> {
        if (this.isPaymentSuccess()) {
            this.stopPaymentStatusPolling();
            return;
        }

        if (manual) {
            this.isCheckingPaymentStatus = true;
        }

        const refId = this.createdOrderData?.payment?.reference_id;
        const orderCode = this.createdOrderData?.order_code || this.bookingCode;
        const orderId = this.createdOrderData?.id;

        const endpointsToCheck: string[] = [];
        if (refId) {
            endpointsToCheck.push(`/api/v1/front/public/orders/detail/${refId}`);
            endpointsToCheck.push(`/api/v1/front/public/orders/check/${refId}`);
        }
        if (orderCode) {
            endpointsToCheck.push(`/api/v1/front/public/orders/show/${orderCode}`);
        }
        if (orderId) {
            endpointsToCheck.push(`/api/v1/front/public/orders/${orderId}`);
        }

        try {
            for (const endpoint of endpointsToCheck) {
                try {
                    let res = await this.apiService.get(endpoint, false);
                    if (!res || !res.success) {
                        const devRes = await fetch(`https://dev.api.visideastudio.com${endpoint}`);
                        if (devRes.ok) {
                            res = await devRes.json();
                        }
                    }

                    if (res && res.data) {
                        const data = res.data;
                        const st = String(data.status || data.payment_status || data.payment?.status || '').toUpperCase();
                        if (['PAID', 'SUCCESS', 'SUCCEEDED', 'COMPLETED', 'SETTLED'].includes(st)) {
                            console.log('✅ Payment Succeeded via API Check:', endpoint, res);
                            this.createdOrderData = { ...this.createdOrderData, ...data };
                            if (this.createdOrderData.payment) {
                                this.createdOrderData.payment.status = 'PAID';
                            }
                            this.triggerPaymentSuccess();
                            break;
                        }
                    }
                } catch (e) {
                    // Ignore errors during status check loops
                }
            }

            if (manual && !this.isPaymentSuccess()) {
                this.copiedToastMsg = 'Status pembayaran masih pending / belum terverifikasi.';
                setTimeout(() => { this.copiedToastMsg = ''; }, 3500);
            }
        } finally {
            if (manual) {
                this.isCheckingPaymentStatus = false;
            }
            this.cdr.markForCheck();
        }
    }

    isPaymentSuccess(): boolean {
        const st = String(
            this.createdOrderData?.status ||
            this.createdOrderData?.payment?.status ||
            ''
        ).toUpperCase();
        return ['PAID', 'SUCCESS', 'SUCCEEDED', 'COMPLETED', 'SETTLED'].includes(st);
    }

    triggerPaymentSuccess(): void {
        if (this.createdOrderData) {
            this.createdOrderData.status = 'PAID';
            if (this.createdOrderData.payment) {
                this.createdOrderData.payment.status = 'PAID';
            }
        }
        this.stopPaymentTimer();
        this.stopPaymentStatusPolling();
        this.isPaymentSuccessModalOpen = true;
        this.cdr.markForCheck();
    }

    closePaymentSuccessModal(): void {
        this.isPaymentSuccessModalOpen = false;
        this.cdr.markForCheck();
    }

    syncStepFromParams(params: any): void {
        const type = params['type'] || '';
        if (type) {
            const tLower = type.toLowerCase();
            if (tLower === 'wedding' || tLower === 'pernikahan' || tLower === 'wedding-invitation' || tLower.includes('wedding')) {
                this.activeCategory = 'wedding-invitation';
            } else if (tLower === 'event' || tLower === 'acara' || tLower === 'guest' || tLower.includes('event')) {
                this.activeCategory = 'event';
            } else {
                this.activeCategory = type;
            }
        } else {
            // Customer MUST select a category first!
            this.setStep('select-category');
            return;
        }

        const packageId = params['packageId'] || '';
        const themeId = params['themeId'] || '';
        this.currentPackageIdParam = packageId;
        this.currentThemeIdParam = themeId;
        this.selectedPackageId = packageId;

        const currentPath = this.router.url || window.location.pathname;

        if (themeId) {
            const tId = String(themeId).toLowerCase().trim();
            let foundTheme = this.allThemes.find((t) => String(t.id).toLowerCase() === tId || String(t.rawUuid || '').toLowerCase() === tId);

            if (!foundTheme && this.selectedTheme && (String(this.selectedTheme.id).toLowerCase() === tId || String(this.selectedTheme.rawUuid || '').toLowerCase() === tId)) {
                foundTheme = this.selectedTheme;
            }

            if (!foundTheme) {
                foundTheme = this.staticMockThemes.find((t: any) => String(t.id).toLowerCase() === tId || String((t as any).rawUuid || '').toLowerCase() === tId);
            }

            if (foundTheme) {
                this.selectedTheme = foundTheme;
            } else if (themeId.length > 5) {
                this.fetchThemedProductById(themeId);
            }

            if (currentPath.includes('/payment')) {
                this.setStep('payment');
                const qParams = this.route.snapshot.queryParams;
                if (qParams && qParams['kodebooking']) {
                    this.bookingCode = qParams['kodebooking'];
                } else if (!this.bookingCode) {
                    this.bookingCode = this.generateBookingCode();
                }

                // Restore createdOrderData from sessionStorage if available
                if (!this.createdOrderData) {
                    try {
                        const savedByCode = this.bookingCode ? sessionStorage.getItem('visidea_order_' + this.bookingCode) : null;
                        const savedCurrent = sessionStorage.getItem('visidea_current_order');
                        const rawSaved = savedByCode || savedCurrent;
                        if (rawSaved) {
                            this.createdOrderData = JSON.parse(rawSaved);
                            console.log('📦 Restored order data from sessionStorage:', this.createdOrderData);
                            if (this.createdOrderData?.payment?.reference_id) {
                                this.subscribePaymentMqtt(this.createdOrderData.payment.reference_id);
                            }
                        }
                    } catch (e) {
                        console.error('Error parsing saved order data:', e);
                    }
                }

                // Immediately render QR from response qr_code_url (or fallback)
                setTimeout(() => this.renderQrisBarcode(), 0);
                return;
            } else if (currentPath.includes('/checkout')) {
                this.setStep('checkout');
                return;
            } else if (currentPath.includes('/detail')) {
                this.setStep('theme-detail');
                return;
            }
        }

        if (packageId) {
            this.setStep('select-theme');
            return;
        }

        this.setStep('select-package');
    }

    async fetchCategories(): Promise<void> {
        this.isLoadingCategories = true;
        try {
            const apiEndpoints = [
                '/api/v1/front/public/invitation-types/list',
                '/api/v1/front/public/invitation-types/list?paginate=false',
                '/api/v1/front/public/invitation-types'
            ];

            let rawList: any[] = [];
            for (const endpoint of apiEndpoints) {
                try {
                    let response = await this.apiService.get(endpoint, false);
                    if (!response || !response.success || !response.data) {
                        try {
                            const devRes = await fetch(`https://dev.api.visideastudio.com${endpoint}`);
                            if (devRes.ok) {
                                response = await devRes.json();
                            }
                        } catch (e) { }
                    }

                    if (response && response.data) {
                        if (Array.isArray(response.data.list)) {
                            rawList = response.data.list;
                        } else if (Array.isArray(response.data)) {
                            rawList = response.data;
                        } else if (Array.isArray(response.data.data)) {
                            rawList = response.data.data;
                        }
                    } else if (Array.isArray(response)) {
                        rawList = response;
                    }

                    if (rawList && rawList.length > 0) {
                        break;
                    }
                } catch (e) { }
            }

            console.log('Invitation Types API Response list:', rawList);

            if (rawList && rawList.length > 0) {
                this.categories = rawList.map((item: any) => {
                    const rawName = String(item.name || item.title || '').trim();
                    const nameLower = rawName.toLowerCase();
                    let routeId = 'wedding-invitation';
                    if (nameLower.includes('wedding') || nameLower.includes('nikah') || nameLower.includes('pernikahan')) {
                        routeId = 'wedding-invitation';
                    } else if (nameLower.includes('event') || nameLower.includes('acara') || nameLower.includes('guest')) {
                        routeId = 'event';
                    } else {
                        routeId = item.slug || nameLower.replace(/\s+/g, '-') || item.id;
                    }

                    let itemImg = item.image_url || item.image || item.cover_image_url || item.cover || item.photo;
                    if (itemImg && typeof itemImg === 'object') {
                        itemImg = itemImg.url || itemImg.image_url || itemImg.src;
                    }
                    if (!itemImg) {
                        if (routeId === 'wedding-invitation') {
                            itemImg = '/assets/visidea/wedding-kategori.PNG';
                        } else {
                            itemImg = '/assets/visidea/event-kategori.JPG';
                        }
                    }

                    return {
                        id: routeId,
                        rawUuid: item.id,
                        name: rawName || (routeId === 'event' ? 'Event' : 'Wedding Invitation'),
                        description: item.description || item.short_description || this.getCategoryDefaultDesc(rawName || routeId),
                        image: itemImg,
                        rawApiData: item
                    };
                });

                // Pastikan Wedding selalu di sebelah kiri (index 0) dan Event di sebelah kanan (index 1)
                this.categories.sort((a, b) => {
                    const aIsWedding = (a.id === 'wedding-invitation' || a.name.toLowerCase().includes('wedding') || a.name.toLowerCase().includes('pernikahan')) ? 1 : 0;
                    const bIsWedding = (b.id === 'wedding-invitation' || b.name.toLowerCase().includes('wedding') || b.name.toLowerCase().includes('pernikahan')) ? 1 : 0;
                    return bIsWedding - aIsWedding;
                });
            }
        } catch (error) {
            console.error('Error fetching invitation types from API:', error);
            if (!this.categories || this.categories.length === 0) {
                this.categories = [
                    {
                        id: 'wedding-invitation',
                        rawUuid: '019f45cb-0c72-70c9-9295-30be2e0a2712',
                        name: 'Wedding',
                        image: '/assets/visidea/wedding-kategori.PNG',
                        description: 'Digital Wedding Invitation Layout Template'
                    },
                    {
                        id: 'event',
                        rawUuid: '01a079ed-d640-72fc-9792-62abe018a8b3',
                        name: 'Event',
                        image: '/assets/visidea/event-kategori.JPG',
                        description: 'Event'
                    }
                ];
            }
        } finally {
            this.isLoadingCategories = false;
            this.cdr.markForCheck();
        }
    }

    getCategoryImage(cat: any): string {
        if (cat?.image) {
            return cat.image;
        }
        const str = String(cat?.name || cat?.id || '').toLowerCase();
        if (str.includes('wedding') || str.includes('invitation') || str.includes('pernikahan')) {
            return '/assets/visidea/photo3.jpg';
        } else if (str.includes('event') || str.includes('guest') || str.includes('acara')) {
            return '/assets/visidea/photo5.jpg';
        }
        return '/assets/visidea/photo3.jpg';
    }

    getCategoryIcon(nameOrId: string, index: number = 0): string {
        const str = String(nameOrId || '').toLowerCase();
        if (str.includes('wedding') || str.includes('invitation') || str.includes('pernikahan')) {
            return '💍';
        } else if (str.includes('event') || str.includes('guest') || str.includes('acara')) {
            return '🎉';
        }
        const icons = ['💍', '🎉'];
        return icons[index % icons.length];
    }

    getCategoryDefaultDesc(nameOrId: string): string {
        const str = String(nameOrId || '').toLowerCase();
        if (str.includes('wedding') || str.includes('invitation') || str.includes('pernikahan')) {
            return 'Solusi undangan online pernikahan eksklusif dengan rincian acara, lokasi maps, RSVP, dan fitur interaktif.';
        } else if (str.includes('event') || str.includes('guest') || str.includes('acara')) {
            return 'Undangan digital & buku tamu modern untuk perayaan Ulang Tahun, Reuni Alumni, Akikah & Gathering.';
        }
        return 'Pilihan kategori produk eksklusif dari Visidea Studio untuk momen istimewa Anda.';
    }

    ngOnInit(): void {
        if (typeof window !== 'undefined' && window.sessionStorage) {
            const savedRel = sessionStorage.getItem('visidea_invitation_religion');
            if (savedRel) {
                this.selectedReligion = savedRel;
            }
        }

        this.fetchCategories();
        this.fetchThemeCategories();
        this.fetchThemedProductPackages();
        this.fetchThemedProducts();

        if (this.createdOrderData?.payment?.reference_id) {
            this.subscribePaymentMqtt(this.createdOrderData.payment.reference_id);
        }

        this.route.params.subscribe((params) => {
            this.syncStepFromParams(params);
        });
    }

    generateBookingCode(): string {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const randomNum = Math.floor(100000 + Math.random() * 900000);
        return `W${yyyy}${mm}${dd}${randomNum}`;
    }

    copyToClipboard(text: string, label: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                this.copiedToastMsg = `${label} berhasil disalin!`;
                setTimeout(() => {
                    this.copiedToastMsg = '';
                }, 3000);
            });
        }
    }

    emailBlurred: boolean = false;
    emailTouched: boolean = false;

    phone = '6282260084847';

    onEmailInput(): void {
        this.emailBlurred = false;
    }

    onEmailBlur(): void {
        this.emailBlurred = true;
    }

    onOtherFieldFocus(): void {
        this.emailTouched = true;
    }

    showEmailEmptyError(): boolean {
        return this.formSubmitted && !this.customerEmail.trim();
    }

    showEmailFormatError(): boolean {
        const email = this.customerEmail.trim();
        if (!email) return false;
        const shouldValidate = this.emailBlurred || this.emailTouched || this.formSubmitted;
        return shouldValidate && !email.includes('@');
    }

    showEmailError(): boolean {
        return this.showEmailEmptyError() || this.showEmailFormatError();
    }

    isEmailInvalid(): boolean {
        const email = this.customerEmail.trim();
        return !email || !email.includes('@');
    }

    onPhoneKeydown(event: KeyboardEvent): void {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
            return;
        }
        if (!/^[0-9]$/.test(event.key)) {
            event.preventDefault();
        }
    }

    onPhoneInput(event: any): void {
        const val = event.target.value || '';
        const cleaned = val.replace(/[^0-9]/g, '');
        this.customerPhone = cleaned;
        if (event.target.value !== cleaned) {
            event.target.value = cleaned;
        }
    }

    subscribePaymentMqtt(referenceId: string): void {
        if (!referenceId) return;

        console.log(`🔌 Initializing MQTT subscription for payment reference: ${referenceId}`);
        this.mqttService.connect();

        const topics = [
            referenceId,
            `payment/${referenceId}`,
            `qris/${referenceId}`,
            `qr.payment`
        ];

        if (this.createdOrderData?.order_code) {
            topics.push(this.createdOrderData.order_code);
            topics.push(`order/${this.createdOrderData.order_code}`);
            topics.push(`orders/${this.createdOrderData.order_code}`);
        }

        topics.forEach((t) => this.mqttService.subscribe(t));

        if (this.mqttSubscription) {
            this.mqttSubscription.unsubscribe();
        }

        this.mqttSubscription = this.mqttService.messages$.subscribe(({ topic, message }) => {
            console.log(`📡 Received MQTT message on topic [${topic}]:`, message);

            const msgUpper = String(message).toUpperCase();
            const topicUpper = String(topic).toUpperCase();
            const refUpper = String(referenceId).toUpperCase();
            const codeUpper = String(this.bookingCode || '').toUpperCase();

            const isTargetOrder =
                topicUpper.includes(refUpper) ||
                topicUpper.includes(codeUpper) ||
                msgUpper.includes(refUpper) ||
                msgUpper.includes(codeUpper) ||
                topicUpper.includes('QR.PAYMENT') ||
                topicUpper.includes('PAYMENT');

            if (isTargetOrder) {
                try {
                    const parsed = JSON.parse(message);
                    const statusData = String(
                        parsed.data?.status ||
                        parsed.status ||
                        parsed.payment_status ||
                        parsed.order_status ||
                        ''
                    ).toUpperCase();
                    const eventName = String(parsed.event || '').toLowerCase();

                    if (
                        ['SUCCEEDED', 'PAID', 'SUCCESS', 'COMPLETED', 'SETTLED'].includes(statusData) ||
                        eventName === 'qr.payment' ||
                        eventName.includes('paid')
                    ) {
                        console.log('✅ Payment Succeeded via MQTT Webhook Payload!');
                        this.triggerPaymentSuccess();
                    }
                } catch (e) {
                    if (
                        msgUpper.includes('SUCCEEDED') ||
                        msgUpper.includes('PAID') ||
                        msgUpper.includes('SUCCESS') ||
                        msgUpper.includes('SETTLED') ||
                        msgUpper.includes('QR.PAYMENT')
                    ) {
                        console.log('✅ Payment Succeeded via MQTT Text Payload!');
                        this.triggerPaymentSuccess();
                    }
                }
            }
        });
    }

    async createOrderApi(): Promise<void> {
        this.isCreatingOrder = true;
        try {
            const selectedPkg = this.getSelectedPackage();
            const packageUuid = selectedPkg?.rawUuid || selectedPkg?.rawApiData?.id || selectedPkg?.id || '0b3bc743-18b4-4407-a242-8c883160a5d4';
            const packageType = selectedPkg?.rawApiData?.product_package_type || 'themed product package';

            const payload: any = {
                package_id: packageUuid,
                product_package_type: packageType,
                name: this.customerName.trim(),
                phone: this.customerPhone.trim(),
                email: this.customerEmail.trim() || 'pemesan@visidea.com',
                payment_channel_id: this.qrisPaymentChannelId,
            };

            if (this.appliedVoucherCode) {
                payload.discount_code = this.appliedVoucherCode;
            }

            const apiEndpoint = '/api/v1/front/public/orders';
            let response = await this.apiService.post(apiEndpoint, payload, false);

            if (!response || !response.success || !response.data) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload),
                    });
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev API order post fallback error:', e);
                }
            }

            if (!response || !response.data) {
                const dynamicCode = this.bookingCode || this.generateBookingCode();
                const dynamicRefSuffix = Math.random().toString(36).substring(2, 8);
                const dynamicRefId = `${dynamicCode}_${dynamicRefSuffix}`;
                const dynamicAmount = this.calculateFinalTotal() || 1;
                const dynamicQr = '00020101021226650013CO.XENDIT.WWW01189360084800000002760215Yt26zmShYBf7tFG0303UME51370014ID.CO.QRIS.WWW0215ID2024357003712520450995303360540115802ID5925PT Adhikari Inovasi Indon6007BANDUNG61054029462290525vCsuGCEp1T2qUwaziJRTZE2Tv6304BF88';
                const nowIso = new Date().toISOString();
                const expiredIso = new Date(Date.now() + 2 * 3600 * 1000).toISOString();
                const dynamicOrderId = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : '01a05b29-863a-7086-a6d1-' + Math.random().toString(16).substring(2, 14);
                const dynamicPaymentId = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : '01a05b29-8646-7252-9baa-' + Math.random().toString(16).substring(2, 14);
                const dynamicTxId = 'qr_' + Math.random().toString(36).substring(2, 10) + '-' + Math.random().toString(36).substring(2, 6);

                const themeName = this.selectedTheme?.title || 'Sparkling Marble';
                const themeAlias = this.selectedTheme?.alias || themeName.substring(0, 6);
                const pkgName = selectedPkg?.name || selectedPkg?.id || 'lite';
                const pkgRegPrice = selectedPkg?.price || dynamicAmount;

                response = {
                    success: true,
                    message: 'Ok',
                    data: {
                        id: dynamicOrderId,
                        order_code: dynamicCode,
                        name: this.customerName.trim(),
                        email: this.customerEmail.trim(),
                        phone: this.customerPhone.trim(),
                        product_category: 'digital invitation',
                        item: themeName,
                        product_package: pkgName,
                        regular_price: pkgRegPrice,
                        price: dynamicAmount,
                        discount_code: this.appliedVoucherCode || null,
                        discount_amount: this.appliedDiscount || 0,
                        grand_price: dynamicAmount,
                        item_snapshot: {
                            product_category: 'digital invitation',
                            item_name: themeName,
                            item: {
                                id: selectedPkg?.rawApiData?.id || 'a5fff233-39d3-4337-ae13-1f31ad527634',
                                name: themeName,
                                alias: themeAlias,
                                short_description: 'digital invitation ',
                                description: `digital invitation ${themeName}`,
                                multiple_background: false,
                                is_active: true,
                                product_category_id: '155630e5-3262-4f0d-8322-8f4d82747250',
                                created_at: nowIso,
                                updated_at: nowIso,
                                deleted_at: null,
                                property: null
                            },
                            package_name: pkgName,
                            package: {
                                id: packageUuid,
                                name: pkgName,
                                description: null,
                                regular_price: pkgRegPrice,
                                price: dynamicAmount,
                                is_active: true,
                                created_at: nowIso,
                                updated_at: nowIso,
                                property: null
                            }
                        },
                        status: 'PENDING',
                        payment_channel_id: this.qrisPaymentChannelId,
                        notes: `Pesanan paket tema untuk acara ${themeName}`,
                        payment: {
                            id: dynamicPaymentId,
                            order_id: dynamicOrderId,
                            payment_channel_id: this.qrisPaymentChannelId,
                            amount: dynamicAmount,
                            transaction_id: dynamicTxId,
                            reference_id: dynamicRefId,
                            virtual_account: null,
                            qr_code_url: dynamicQr,
                            expired_at: expiredIso,
                            status: 'pending',
                            created_at: nowIso
                        },
                        created_at: nowIso
                    },
                    is_event: false
                };
            }

            if (response && response.data) {
                this.createdOrderData = response.data;
                try {
                    sessionStorage.setItem('visidea_current_order', JSON.stringify(response.data));
                    if (response.data.order_code) {
                        sessionStorage.setItem('visidea_order_' + response.data.order_code, JSON.stringify(response.data));
                    }
                } catch (e) {
                    console.error('Error saving order to sessionStorage:', e);
                }

                // Await the QR render so qrisDataUrl is ready before navigate
                await this.renderQrisBarcode();
                if (response.data.order_code) {
                    this.bookingCode = response.data.order_code;
                }
                const referenceId = response.data.payment?.reference_id;
                if (referenceId) {
                    this.subscribePaymentMqtt(referenceId);
                }
            }
        } catch (error) {
            console.error('Error creating order via API:', error);
        } finally {
            this.isCreatingOrder = false;
        }
    }

    async submitOrder(): Promise<void> {
        this.formSubmitted = true;
        this.emailTouched = true;
        this.emailBlurred = true;

        if (this.isEmailInvalid()) {
            return;
        }

        if (!this.customerName.trim() || !this.customerPhone.trim()) {
            return;
        }

        if (!this.agreeTerms) {
            return;
        }

        await this.createOrderApi();

        if (!this.bookingCode) {
            this.bookingCode = this.generateBookingCode();
        }

        const pkgId = this.selectedPackageId || 'exclusive';
        const themeId = this.selectedTheme ? this.selectedTheme.id : 1;

        this.router.navigate(
            ['/digital-invitation', this.activeCategory, pkgId, 'payment', themeId],
            { queryParams: { kodebooking: this.bookingCode } }
        );
    }

    computeQrisCrc16(payloadWithoutCrc: string): string {
        let crc = 0xffff;
        for (let i = 0; i < payloadWithoutCrc.length; i++) {
            crc ^= payloadWithoutCrc.charCodeAt(i) << 8;
            for (let j = 0; j < 8; j++) {
                if ((crc & 0x8000) !== 0) {
                    crc = ((crc << 1) ^ 0x1021) & 0xffff;
                } else {
                    crc = (crc << 1) & 0xffff;
                }
            }
        }
        return (crc & 0xffff).toString(16).toUpperCase().padStart(4, '0');
    }

    buildEmvTlv(tag: string, value: string): string {
        const len = value.length.toString().padStart(2, '0');
        return `${tag}${len}${value}`;
    }

    generateDynamicXenditQris(amount: number, refId: string): string {
        const xenditMerchantBase = '00020101021226650013CO.XENDIT.WWW01189360084800000002760215Yt26zmShYBf7tFG0303UME51370014ID.CO.QRIS.WWW0215ID202435700371252520450995303360';
        const tag54 = this.buildEmvTlv('54', String(amount));
        const tag58 = '5802ID';
        const tag59 = this.buildEmvTlv('59', 'PT Adhikari Inovasi Indon');
        const tag60 = this.buildEmvTlv('60', 'BANDUNG');
        const tag61 = this.buildEmvTlv('61', '40294');
        const tag62Sub05 = this.buildEmvTlv('05', (refId || 'vCsuGCEp1T2qUwaziJRTZE2Tv').slice(0, 25));
        const tag62 = this.buildEmvTlv('62', tag62Sub05);
        const payloadBase = `${xenditMerchantBase}${tag54}${tag58}${tag59}${tag60}${tag61}${tag62}6304`;
        const crc = this.computeQrisCrc16(payloadBase);
        return `${payloadBase}${crc}`;
    }

    /** Returns true if the given string looks like an image URL (not a QRIS EMV payload). */
    isImageUrl(value: string): boolean {
        if (!value) return false;
        const lower = value.toLowerCase();
        return (
            lower.startsWith('data:image/') ||
            /\.(png|jpg|jpeg|gif|svg|webp)(\?.*)?$/.test(lower) ||
            lower.includes('/qrcode') ||
            lower.includes('/qr-code') ||
            lower.includes('/qr_code') ||
            lower.includes('qrimage') ||
            lower.includes('create-qr-code')
        );
    }

    sanitizeAndFixQrisString(rawQr: string): string {
        if (!rawQr || typeof rawQr !== 'string') return '';
        let cleaned = rawQr.trim();
        // If it's an image URL or data URL, return as-is for direct display
        if (this.isImageUrl(cleaned)) {
            return cleaned;
        }
        // If it's a non-image HTTP URL (e.g. Xendit deeplink), use it as QR data
        if (cleaned.startsWith('http://') || cleaned.startsWith('https://')) {
            return cleaned;
        }

        // Fix missing Tag 52 (Merchant Category Code) if backend string omitted 52 before 045099
        if (!cleaned.includes('52045') && cleaned.includes('0450995303360')) {
            cleaned = cleaned.replace('0450995303360', '520450995303360');
        } else if (!cleaned.includes('52045') && /ID2024[0-9]{13}045[0-9]{3}5303360/.test(cleaned)) {
            cleaned = cleaned.replace(/045([0-9]{3}5303360)/, '52045$1');
        }

        // Recompute CRC-16 if Tag 6304 is present
        const idx6304 = cleaned.indexOf('6304');
        if (idx6304 !== -1) {
            const basePayload = cleaned.substring(0, idx6304 + 4);
            const validCrc = this.computeQrisCrc16(basePayload);
            return `${basePayload}${validCrc}`;
        }

        return cleaned;
    }

    getQrisRawString(): string {
        const apiQr = this.createdOrderData?.payment?.qr_code_url;
        if (apiQr && typeof apiQr === 'string' && apiQr.trim().length > 0) {
            const trimmed = apiQr.trim();
            console.log('📌 [QRIS] Using exact qr_code_url from API order response:', trimmed);
            // If it's a valid QRIS EMV string from the API (starts with '000201'),
            // use it DIRECTLY — the API already computed the correct CRC.
            if (trimmed.startsWith('000201')) {
                return trimmed;
            }
            // For image URLs, deeplinks, or malformed strings — sanitize.
            return this.sanitizeAndFixQrisString(trimmed);
        }

        // Fallback: generate dynamic QRIS with the actual payment amount
        const amount = this.createdOrderData?.payment?.amount || this.calculateFinalTotal() || 1;
        const refId = this.createdOrderData?.payment?.reference_id || this.bookingCode || 'vCsuGCEp1T2qUwaziJRTZE2Tv';
        console.warn('⚠️ [QRIS] No payment.qr_code_url found, using fallback dynamic QRIS for amount:', amount);
        return this.generateDynamicXenditQris(amount, refId);
    }

    getQrisQrCodeUrl(): string {
        const rawQr = this.getQrisRawString();
        // If the API returned an image URL directly, return it for <img> src
        if (rawQr.startsWith('data:image/') || this.isImageUrl(rawQr)) {
            return rawQr;
        }
        // If we already rendered it locally, return that
        if (this.qrisDataUrl && this.qrisDataUrl.length > 0) {
            return this.qrisDataUrl;
        }
        this.renderQrisBarcode();
        // Fallback to external QR generator while local render completes
        return `https://api.qrserver.com/v1/create-qr-code/?size=500x500&ecc=M&margin=12&data=${encodeURIComponent(rawQr)}`;
    }

    async renderQrisBarcode(): Promise<void> {
        try {
            const raw = this.getQrisRawString();
            if (!raw) {
                this.qrisDataUrl = '';
                this.cdr.markForCheck();
                return;
            }
            // If the value is already an image URL, use it directly as <img src>
            if (raw.startsWith('data:image/') || this.isImageUrl(raw)) {
                this.qrisDataUrl = raw;
                this.cdr.markForCheck();
                return;
            }
            // Generate a high-quality PNG data URL from the QRIS EMV string.
            // Render at 300px — displayed at w-56/w-64 (224–256px) so this is crisp without excess.
            const dataUrl = await QRCode.toDataURL(raw, {
                errorCorrectionLevel: 'M',
                margin: 2,
                width: 300,
                color: {
                    dark: '#000000',
                    light: '#ffffff',
                },
            });
            this.qrisDataUrl = dataUrl;
            // Force Angular change detection — this Promise resolves outside Angular zone
            this.cdr.markForCheck();
        } catch (err) {
            console.error('Error rendering QRCode barcode:', err);
        }
    }

    copyQrisString(): void {
        const raw = this.getQrisRawString();
        if (raw) {
            navigator.clipboard.writeText(raw).then(() => {
                this.copiedToastMsg = 'Payload QRIS berhasil disalin!';
                setTimeout(() => { this.copiedToastMsg = ''; }, 3000);
            }).catch(() => { });
        }
    }

    confirmPaymentViaWhatsapp(): void {
        const pkg = this.getSelectedPackage();
        const theme = this.selectedTheme;
        const religion = this.getReligionPreset();
        const color = this.getColorSchemePreset();
        const addons = Object.values(this.selectedAddonsMap);
        const finalTotal = this.calculateFinalTotal();

        let addonsText =
            addons.length > 0
                ? addons
                    .map((a) =>
                        a.addonObj.hasQuantity
                            ? `• ${a.addonObj.name}: ${a.qty} ${a.addonObj.unit || ''}`
                            : `• ${a.addonObj.name}`,
                    )
                    .join('\n')
                : 'Tidak ada (Fitur Standar)';

        const msg = `Halo IT Support Visidea Studio, saya telah melakukan pemesanan Undangan Digital:

🧾 *KODE ORDER:* ${this.bookingCode}
💳 *METODE PEMBAYARAN:* QRIS Instant

👤 *DATA PEMESAN*
• *Nama Lengkap:* ${this.customerName.trim()}
• *No. WhatsApp:* ${this.customerPhone.trim()}
• *Email:* ${this.customerEmail.trim() || '-'}

📌 *INFORMASI PESANAN*
• *Kategori:* ${this.getCategoryTitle()}
• *Paket:* ${pkg?.name} (Rp${pkg?.price.toLocaleString()})
• *Tema Desain:* ${theme?.title || 'Paradise'}
• *Preset Doa/Agama:* ${religion.label}
• *Skema Warna:* ${color.name}

🎁 *ADD-ON FITUR TAMBAHAN*
${addonsText}

💰 *TOTAL PEMBAYARAN:* Rp${finalTotal.toLocaleString()}

Berikut bukti konfirmasi pembayaran QRIS terlampir. Mohon verifikasi dan proses pesanan saya. Terima kasih!`;

        const url = `https://wa.me/${this.phone}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    }

    orderCustomizedViaWhatsapp(): void {
        this.goToCheckout();
    }

    orderViaWhatsapp(packageNameOrTheme?: string): void {
        const selectedPkg = this.getSelectedPackage();
        const msg = packageNameOrTheme
            ? `Halo Visidea Studio, saya tertarik untuk memesan Undangan Digital (${selectedPkg?.name || 'Paket'}) dengan pilihan: "${packageNameOrTheme}". Mohon info penawaran dan proses pemesanannya. Terima kasih!`
            : `Halo Visidea Studio, saya berminat memesan Undangan Digital. Boleh minta informasi lebih lengkap? Terima kasih!`;
        const url = `https://wa.me/${this.phone}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    }

    getCategoryTitle(): string {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            return 'Undangan Digital Event';
        }
        return 'Undangan Digital Wedding';
    }

    getCategoryDesc(): string {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            return 'Rayakan berbagai momen istimewa seperti ulang tahun, reuni, dan gathering dengan undangan digital & buku tamu yang modern.';
        }
        return 'Jadikan pernikahanmu lebih bermakna dengan berbagai pilihan desain yang menarik dan fitur interaktif.';
    }

    getPackageSectionDesc(): string {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            return 'Pilih paket paling cocok buat acara kamu untuk melihat pilihan desain';
        }
        return 'Pilih paket sesuai kebutuhan pernikahan kamu untuk melihat pilihan desain.';
    }

    chooseCategory(catId: string): void {
        this.activeCategory = catId;
        this.activeThemeCategory = 'all';
        this.addonPageIndex = 0;
        this.selectedPackageId = '';
        this.selectedTheme = null;
        this.router.navigate(['/digital-invitation', catId]).then(() => {
            setTimeout(() => {
                const el = document.getElementById('pilih-paket-section');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 200);
        });
    }

    defaultBenefitsLimit: number = 5;

    toggleShowMorePackage(pkg: any, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        const willExpand = !pkg.showMore;
        if (willExpand && this.pricingPackages) {
            this.pricingPackages.forEach((p: any) => {
                if (p !== pkg) {
                    p.showMore = false;
                }
            });
        }
        pkg.showMore = willExpand;
        this.cdr.markForCheck();
    }

    getPackageIconType(pkg: any): string {
        const name = String(pkg?.name || '').toLowerCase();
        if (name.includes('exclusive') || name.includes('vip') || name.includes('gold')) {
            return 'exclusive';
        }
        if (name.includes('premium') || name.includes('pro')) {
            return 'premium';
        }
        return 'lite';
    }

    choosePackage(pkgId: string): void {
        this.selectedPackageId = pkgId;
        this.activeThemeCategory = 'all';
        this.router.navigate(['/digital-invitation', this.activeCategory, pkgId]);
    }

    backToPackageSelection(): void {
        this.selectedPackageId = '';
        this.selectedTheme = null;
        this.activeThemeCategory = 'all';
        this.router.navigate(['/digital-invitation', this.activeCategory]);
    }

    backToCategorySelection(): void {
        this.selectedPackageId = '';
        this.selectedTheme = null;
        this.router.navigate(['/digital-invitation']);
    }

    goToHome(): void {
        this.selectedPackageId = '';
        this.selectedTheme = null;
        this.createdOrderData = null;
        this.stopPaymentTimer();
        this.stopPaymentStatusPolling();
        try {
            sessionStorage.removeItem('visidea_current_order');
        } catch (e) { }
        this.router.navigate(['/digital-invitation', this.activeCategory]);
    }

    isCustomEventModalOpen: boolean = false;
    isSubmittingCustomEvent: boolean = false;
    customEventForm = {
        eventName: '',
        eventType: 'Ulang Tahun / Sweet 17',
        conceptTheme: '',
        colorPalette: '',
        designReference: '',
        specialNotes: '',
        contactName: '',
        contactPhone: ''
    };

    openCustomEventModal(): void {
        this.isCustomEventModalOpen = true;
    }

    closeCustomEventModal(): void {
        this.isCustomEventModalOpen = false;
    }

    submitCustomEventRequest(): void {
        if (!this.customEventForm.eventName || !this.customEventForm.contactPhone) {
            Swal.fire({
                icon: 'warning',
                title: 'Data Belum Lengkap',
                text: 'Harap isi nama acara dan nomor WhatsApp kontak Anda.',
                confirmButtonColor: '#202367'
            });
            return;
        }

        const msg = `Halo Visidea Studio, saya ingin memesan *Custom Event Digital Invitation*:%0A%0A` +
            `• *Nama Acara*: ${encodeURIComponent(this.customEventForm.eventName)}%0A` +
            `• *Jenis Acara*: ${encodeURIComponent(this.customEventForm.eventType)}%0A` +
            `• *Konsep / Tema Desain*: ${encodeURIComponent(this.customEventForm.conceptTheme || '-')}%0A` +
            `• *Warna / Palet Pilihan*: ${encodeURIComponent(this.customEventForm.colorPalette || '-')}%0A` +
            `• *Referensi Desain*: ${encodeURIComponent(this.customEventForm.designReference || '-')}%0A` +
            `• *Catatan Tambahan*: ${encodeURIComponent(this.customEventForm.specialNotes || '-')}%0A` +
            `• *Nama Pemesan*: ${encodeURIComponent(this.customEventForm.contactName || '-')}%0A` +
            `• *Kontak WA*: ${encodeURIComponent(this.customEventForm.contactPhone)}%0A%0A` +
            `Mohon dibantu informasi penawaran dan konsultasi desainnya. Terima kasih!`;

        const waUrl = `https://wa.me/6282260084847?text=${msg}`;

        // Also add to cart as custom event item
        this.cartService.addItem({
            id: 'custom_event_request_' + Date.now(),
            name: `Custom Event: ${this.customEventForm.eventName} (${this.customEventForm.eventType})`,
            category: 'Undangan Digital - Custom Event',
            price: 250000,
            image: '/assets/visidea/themes/cover-theme43.png',
            description: `Custom theme request: ${this.customEventForm.conceptTheme || 'Custom Concept'}, Ref: ${this.customEventForm.designReference || 'Via WhatsApp'}`,
            selectedOption: `Konsep: ${this.customEventForm.conceptTheme || 'Custom'}`
        }, 1);

        this.closeCustomEventModal();

        Swal.fire({
            icon: 'success',
            title: 'Request Berhasil Dikirim!',
            text: 'Pesanan telah masuk ke keranjang. Anda juga dapat langsung berkonsultasi dengan tim kreatif Visidea via WhatsApp.',
            confirmButtonText: 'Buka WhatsApp',
            confirmButtonColor: '#10B981',
            showCancelButton: true,
            cancelButtonText: 'Tutup'
        }).then((res) => {
            if (res.isConfirmed && typeof window !== 'undefined') {
                window.open(waUrl, '_blank');
            }
        });
    }

    openThemeDetail(theme: any): void {
        if (theme.isCustomEvent || theme.alias === 'custom-event-invitation') {
            this.openCustomEventModal();
            return;
        }
        this.selectedTheme = theme;
        const pkgId = this.selectedPackageId || 'exclusive';
        this.router.navigate(['/digital-invitation', this.activeCategory, pkgId, 'detail', theme.id]);
    }

    backToThemeSelection(): void {
        const pkgId = this.selectedPackageId || 'exclusive';
        this.router.navigate(['/digital-invitation', this.activeCategory, pkgId]);
    }

    goToCheckout(): void {
        if (!this.selectedTheme && this.allThemes.length > 0) {
            this.selectedTheme = this.allThemes[0];
        }
        const pkgId = this.selectedPackageId || 'exclusive';
        const themeId = this.selectedTheme ? this.selectedTheme.id : 1;
        this.router.navigate([
            '/digital-invitation',
            this.activeCategory,
            pkgId,
            'checkout',
            themeId,
        ]);
    }

    backToThemeDetail(): void {
        const pkgId = this.selectedPackageId || 'exclusive';
        if (this.selectedTheme) {
            this.router.navigate([
                '/digital-invitation',
                this.activeCategory,
                pkgId,
                'detail',
                this.selectedTheme.id,
            ]);
        } else {
            this.backToThemeSelection();
        }
    }

    backToCheckout(): void {
        const pkgId = this.selectedPackageId || 'exclusive';
        const themeId = this.selectedTheme ? this.selectedTheme.id : 1;
        this.router.navigate([
            '/digital-invitation',
            this.activeCategory,
            pkgId,
            'checkout',
            themeId,
        ]);
    }

    getSelectedPackage() {
        if (this.pricingPackages && this.pricingPackages.length > 0) {
            const targetId = String(this.selectedPackageId || this.currentPackageIdParam || '').toLowerCase().trim();
            const found = this.pricingPackages.find(p =>
                String(p.id).toLowerCase() === targetId ||
                String(p.rawUuid || '').toLowerCase() === targetId ||
                String(p.apiPackageKey || '').toLowerCase() === targetId ||
                String(p.name || '').toLowerCase() === targetId
            );
            if (found) return found;
            return this.pricingPackages[0];
        }
        return {
            id: this.selectedPackageId || this.currentPackageIdParam || '',
            name: '',
            price: 0,
            priceFormatted: 'Rp 0',
            description: '',
            benefits: []
        };
    }

    activePreviewImageIndex: number = 0;

    getThemePreviewImages(theme: any): string[] {
        if (!theme) return [];
        const list: string[] = [];
        const addIfValid = (url: any) => {
            if (typeof url === 'string' && url.trim().length > 0 && !list.includes(url.trim())) {
                list.push(url.trim());
            }
        };

        addIfValid(theme.image);
        addIfValid(theme.hoverImage);
        addIfValid(theme.rawApiData?.cover_image_url);
        addIfValid(theme.rawApiData?.background_image_url);
        if (Array.isArray(theme.rawApiData?.images)) {
            theme.rawApiData.images.forEach((img: any) => {
                const u = typeof img === 'string' ? img : (img?.url || img?.image_url || img?.src);
                addIfValid(u);
            });
        }
        if (Array.isArray(theme.rawApiData?.gallery)) {
            theme.rawApiData.gallery.forEach((img: any) => {
                const u = typeof img === 'string' ? img : (img?.url || img?.image_url || img?.src);
                addIfValid(u);
            });
        }
        if (list.length === 0 && theme.image) {
            list.push(theme.image);
        }
        return list;
    }

    prevPreviewImage(total: number): void {
        if (total <= 1) return;
        this.activePreviewImageIndex = (this.activePreviewImageIndex - 1 + total) % total;
    }

    nextPreviewImage(total: number): void {
        if (total <= 1) return;
        this.activePreviewImageIndex = (this.activePreviewImageIndex + 1) % total;
    }

    setPreviewImageIndex(idx: number): void {
        this.activePreviewImageIndex = idx;
    }

    setCategory(catId: string): void {
        this.activeCategory = catId;
        this.addonPageIndex = 0;
        if (this.currentStep === 'select-theme' && this.selectedPackageId) {
            this.router.navigate(['/digital-invitation', catId, this.selectedPackageId]);
        } else if (this.currentStep === 'theme-detail' && this.selectedTheme) {
            const pkgId = this.selectedPackageId || 'exclusive';
            this.router.navigate(['/digital-invitation', catId, pkgId, 'detail', this.selectedTheme.id]);
        } else if (this.currentStep === 'checkout' && this.selectedTheme) {
            const pkgId = this.selectedPackageId || 'exclusive';
            this.router.navigate(['/digital-invitation', catId, pkgId, 'checkout', this.selectedTheme.id]);
        } else {
            this.router.navigate(['/digital-invitation', catId]);
        }
    }

    setThemeCategoryFilter(catId: string): void {
        this.activeThemeCategory = catId;
    }

    addToCart(theme: any, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        if (theme.isCustomEvent || theme.alias === 'custom-event-invitation') {
            this.openCustomEventModal();
            return;
        }
        const pkg = this.getSelectedPackage();
        const price = (pkg?.price !== undefined && pkg?.price !== null) ? Number(pkg.price) : 150000;
        const packageUuid = pkg?.rawUuid || pkg?.id;
        const themeUuid = theme?.rawUuid || theme?.id;
        const themeTitle = theme?.title || theme?.name || 'Tema Undangan';

        this.cartService.addItem({
            id: themeUuid && this.cartService.isUuid(themeUuid) ? themeUuid : `theme_${theme.id || Math.random().toString(36).substr(2, 6)}`,
            itemable_type: 'ThemedProductPackage',
            itemable_id: packageUuid,
            custom_options: {
                themed_product_id: themeUuid && this.cartService.isUuid(themeUuid) ? themeUuid : null,
                themed_product_name: themeTitle,
                themed_product_image: theme.image || theme.cover_image || theme.rawApiData?.cover_image_url || null,
            },
            name: `Undangan Digital: ${themeTitle} (${pkg?.name || 'Paket Exclusive'})`,
            category: `Undangan Digital - ${theme.tag || theme.themeCategory || 'Wedding'}`,
            price: price,
            image: theme.image || '/assets/visidea/theme-1.jpg',
            description: theme.description || `Tema desain ${themeTitle} dengan paket ${pkg?.name}`,
            selectedOption: `Paket: ${pkg?.name || 'Standard'}`
        }, 1);

        this.cartToastMsg = `"${themeTitle}" berhasil dimasukkan ke keranjang!`;
        setTimeout(() => {
            this.cartToastMsg = '';
        }, 3000);

        this.cartService.openCart();
    }

    openInvoiceModal(): void {
        const pkg = this.getSelectedPackage();
        const finalAmount = this.calculateFinalTotal();
        const now = new Date();
        const formattedDate = new Intl.DateTimeFormat('id-ID', {
            dateStyle: 'full',
            timeStyle: 'short',
        }).format(now);

        const invCode = 'INV/' + now.getFullYear() + '/VIS-' + (this.bookingCode || this.generateBookingCode()).replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 8);

        this.invoiceData = {
            invoiceNumber: invCode,
            orderCode: this.createdOrderData?.order_code || this.bookingCode || 'VIS-89241',
            invoiceDate: formattedDate,
            customerName: this.customerName || 'Pelanggan Terhormat',
            customerPhone: this.customerPhone || '081234567890',
            customerEmail: this.customerEmail || 'pelanggan@visidea.com',
            packageName: pkg?.name || 'Paket Exclusive',
            packagePrice: pkg?.price || 150000,
            themeTitle: this.selectedTheme?.title || 'Sparkling Marble',
            themeCategory: this.selectedTheme?.tag || 'Luxury Wedding',
            selectedReligion: this.religions.find(r => r.id === this.selectedReligion)?.label || 'Umum / Nasional',
            selectedColorScheme: this.colorSchemes.find(c => c.id === this.selectedColorScheme)?.name || 'Misty Sage',
            selectedAddons: this.getSelectedAddonsList(),
            voucherCode: this.appliedVoucherCode || null,
            discountAmount: this.appliedDiscount || 0,
            totalAmount: finalAmount,
            paymentMethod: this.selectedPaymentMethod === 'qris' ? 'QRIS Instant Verification' : 'Bank Transfer',
            paymentStatus: 'PAID / LUNAS',
            paymentChannel: 'Visidea Automated Gateway'
        };

        this.isInvoiceModalOpen = true;
    }

    closeInvoiceModal(): void {
        this.isInvoiceModalOpen = false;
    }

    printInvoice(): void {
        if (typeof window !== 'undefined') {
            window.print();
        }
    }

    getFilteredThemes(): any[] {
        let pool = (this.allThemes && this.allThemes.length > 0) ? [...this.allThemes] : [...this.staticMockThemes];

        const activeCatLower = String(this.activeCategory || '').toLowerCase().trim();
        const activeSubCat = String(this.activeThemeCategory || 'all').toLowerCase().trim();
        const isEvent = activeCatLower.includes('event') || activeCatLower.includes('guest') || activeCatLower.includes('acara');

        // Always ensure Custom Event Invitation (id: 805) is present in event pool
        if (isEvent) {
            const hasCustom = pool.some((t) => t.isCustomEvent || t.id === 805 || t.alias === 'custom-event-invitation');
            if (!hasCustom) {
                const customTheme = this.staticMockThemes.find((t) => t.isCustomEvent || t.id === 805);
                if (customTheme) {
                    pool = [customTheme, ...pool];
                }
            }
        }

        // Get selected package info for dynamic filtering
        const targetPkg = this.getSelectedPackage();
        const targetPkgId = String(targetPkg?.rawUuid || targetPkg?.id || this.selectedPackageId || this.currentPackageIdParam || '').toLowerCase().trim();
        const targetPkgName = String(targetPkg?.name || targetPkg?.apiPackageKey || '').toLowerCase().trim();

        const filtered = pool.filter((theme) => {
            // 1. Filter by Main Category (Pernikahan / Wedding vs Acara / Event)
            const themeCat = String(theme.category || '').toLowerCase().trim();

            if (isEvent) {
                const matchEvent = themeCat === 'event' || themeCat.includes('event') || themeCat.includes('acara') || theme.isCustomEvent;
                if (!matchEvent) return false;
            } else {
                if (theme.isCustomEvent || theme.id === 805 || theme.alias === 'custom-event-invitation') return false;
                if (themeCat.includes('event') || themeCat.includes('acara')) return false;
                const matchWedding = themeCat === 'wedding' || themeCat.includes('wedding') || themeCat.includes('pernikahan') || !themeCat;
                if (!matchWedding) return false;
            }

            // 2. Filter by Selected Package (Lite, Premium, Exclusive) for Wedding Invitations
            if (!isEvent && (targetPkgId || targetPkgName)) {
                let matchesPackage = false;

                // A. Check against rawApiData.packages (from API)
                if (Array.isArray(theme.rawApiData?.packages) && theme.rawApiData.packages.length > 0) {
                    matchesPackage = theme.rawApiData.packages.some((p: any) => {
                        const pId = String(p.id || '').toLowerCase().trim();
                        const pName = String(p.name || '').toLowerCase().trim();
                        return (targetPkgId && pId === targetPkgId) ||
                               (targetPkgId && pName === targetPkgId) ||
                               (targetPkgName && (pName === targetPkgName || targetPkgName.includes(pName) || pName.includes(targetPkgName)));
                    });
                }
                // B. Check against suitablePackages
                else if (Array.isArray(theme.suitablePackages) && theme.suitablePackages.length > 0) {
                    matchesPackage = theme.suitablePackages.some((sp: any) => {
                        const spLower = String(sp).toLowerCase().trim();
                        return (targetPkgId && spLower === targetPkgId) ||
                               (targetPkgName && (spLower === targetPkgName || targetPkgName.includes(spLower) || spLower.includes(targetPkgName))) ||
                               (targetPkgId && (spLower.includes(targetPkgId) || targetPkgId.includes(spLower)));
                    });
                }
                // C. Check against packages array
                else if (Array.isArray(theme.packages) && theme.packages.length > 0) {
                    matchesPackage = theme.packages.some((p: any) => {
                        const pId = String(typeof p === 'object' ? (p.id || '') : p).toLowerCase().trim();
                        const pName = String(typeof p === 'object' ? (p.name || '') : p).toLowerCase().trim();
                        return (targetPkgId && pId === targetPkgId) ||
                               (targetPkgId && pName === targetPkgId) ||
                               (targetPkgName && (pName === targetPkgName || targetPkgName.includes(pName) || pName.includes(targetPkgName)));
                    });
                } else {
                    matchesPackage = true;
                }

                if (!matchesPackage) {
                    return false;
                }
            }

            // 3. Filter by Theme Sub-Category (Dynamic from DB / API or inferred)
            if (activeSubCat !== 'all') {
                const themeSubCat = String(theme.themeCategory || '').toLowerCase().trim();
                const themeTitle = String(theme.title || '').toLowerCase();
                const themeTag = String(theme.tag || '').toLowerCase();
                const themeBadge = String(theme.badge || '').toLowerCase();

                let matchesCategoryObject = false;
                if (Array.isArray(theme.themeCategories)) {
                    matchesCategoryObject = theme.themeCategories.some((tc: any) => {
                        const tcId = String(tc.id || '').toLowerCase().trim();
                        const tcSlug = String(tc.slug || '').toLowerCase().trim();
                        const tcName = String(tc.name || tc.title || '').toLowerCase().trim();
                        return tcId === activeSubCat || tcSlug === activeSubCat || tcName === activeSubCat || tcName.includes(activeSubCat);
                    });
                }

                let matchesCategoryRules = false;
                if (activeSubCat === 'ulang-tahun' || activeSubCat === 'birthday') {
                    matchesCategoryRules = themeSubCat.includes('ulang') || themeSubCat.includes('birthday') ||
                        themeTitle.includes('birthday') || themeTitle.includes('ulang tahun') || themeTitle.includes('sweet') ||
                        themeTag.includes('birthday') || themeTag.includes('ulang tahun');
                } else if (activeSubCat === 'wisuda' || activeSubCat === 'graduation') {
                    matchesCategoryRules = themeSubCat.includes('wisuda') || themeSubCat.includes('graduat') ||
                        themeTitle.includes('wisuda') || themeTitle.includes('univeristy') || themeTitle.includes('university') ||
                        themeTag.includes('wisuda');
                } else if (activeSubCat === 'grand-opening' || activeSubCat === 'opening') {
                    matchesCategoryRules = themeSubCat.includes('opening') || themeSubCat.includes('grand-opening') ||
                        themeTitle.includes('opening') || themeTitle.includes('peresmian') || themeTitle.includes('tedja') || themeTitle.includes('fotokapsul') || themeTitle.includes('drama musikal') || themeTitle.includes('pentas drama') ||
                        themeTag.includes('opening') || themeTag.includes('grand opening');
                } else if (activeSubCat === 'aqiqah') {
                    matchesCategoryRules = themeSubCat.includes('aqiqah') || themeSubCat.includes('akikah') ||
                        themeTitle.includes('aqiqah') || themeTitle.includes('starry pink') || themeTag.includes('aqiqah');
                } else if (activeSubCat === 'khitan') {
                    matchesCategoryRules = themeSubCat.includes('khitan') || themeSubCat.includes('sunat') ||
                        themeTitle.includes('khitan') || themeTitle.includes('mustika rahayu') || themeTag.includes('khitan');
                }

                const matchesSubCategory =
                    matchesCategoryRules ||
                    matchesCategoryObject ||
                    themeSubCat === activeSubCat ||
                    themeSubCat.includes(activeSubCat) ||
                    themeTitle.includes(activeSubCat) ||
                    themeTag.includes(activeSubCat) ||
                    themeBadge.includes(activeSubCat);

                if (!matchesSubCategory) {
                    return false;
                }
            }

            return true;
        });

        // For Event category, guarantee Custom Event Invitation is sorted first (top-left)
        if (isEvent) {
            filtered.sort((a, b) => {
                const aCustom = (a.isCustomEvent || a.id === 805) ? 1 : 0;
                const bCustom = (b.isCustomEvent || b.id === 805) ? 1 : 0;
                return bCustom - aCustom;
            });
        }

        return filtered;
    }

    // Addon Category Helpers
    getAvailableAddonsForCurrentCategory() {
        const cat = String(this.activeCategory || '').toLowerCase();
        if (cat.includes('event') || cat.includes('acara') || cat.includes('guest')) {
            return this.categoryAddons['acara'] || [];
        }
        return this.categoryAddons['pernikahan'] || [];
    }

    getPaginatedAddons() {
        const list = this.getAvailableAddonsForCurrentCategory();
        const start = this.addonPageIndex * 3;
        return list.slice(start, start + 3);
    }

    getAddonPages(): number[] {
        const total = Math.ceil(this.getAvailableAddonsForCurrentCategory().length / 3);
        return Array.from({ length: total }, (_, i) => i);
    }

    setAddonPage(pageIndex: number): void {
        this.addonPageIndex = pageIndex;
    }

    // Addon Card Click Handler
    clickAddonCard(addon: any): void {
        if (addon.hasQuantity) {
            this.openAddonQtyModal(addon);
        } else {
            if (this.selectedAddonsMap[addon.id]) {
                delete this.selectedAddonsMap[addon.id];
            } else {
                this.selectedAddonsMap[addon.id] = {
                    qty: 1,
                    unitPrice: addon.unitPrice,
                    totalPrice: addon.unitPrice,
                    addonObj: addon,
                };
            }
        }
    }

    isAddonSelected(addonId: string): boolean {
        return !!this.selectedAddonsMap[addonId];
    }

    getAddonQty(addonId: string): number {
        return this.selectedAddonsMap[addonId]?.qty || 0;
    }

    // Quantity Modal Controls
    openAddonQtyModal(addon: any): void {
        this.activeModalAddon = addon;
        const existing = this.selectedAddonsMap[addon.id];
        this.modalQty = existing ? existing.qty : addon.defaultQty || 1;
        this.isAddonQtyModalOpen = true;
    }

    closeAddonQtyModal(): void {
        this.isAddonQtyModalOpen = false;
        this.activeModalAddon = null;
    }

    increaseModalQty(): void {
        if (!this.activeModalAddon) return;
        const step = this.activeModalAddon.step || 1;
        const max = this.activeModalAddon.maxQty || 1000;
        if (this.modalQty + step <= max) {
            this.modalQty += step;
        }
    }

    decreaseModalQty(): void {
        if (!this.activeModalAddon) return;
        const step = this.activeModalAddon.step || 1;
        const min = this.activeModalAddon.minQty || 1;
        if (this.modalQty - step >= min) {
            this.modalQty -= step;
        }
    }

    confirmAddonModal(): void {
        if (!this.activeModalAddon) return;
        const unitPrice = this.activeModalAddon.unitPrice || 0;
        const total = unitPrice * this.modalQty;
        this.selectedAddonsMap[this.activeModalAddon.id] = {
            qty: this.modalQty,
            unitPrice: unitPrice,
            totalPrice: total,
            addonObj: this.activeModalAddon,
        };
        this.closeAddonQtyModal();
    }

    cancelCurrentModalAddon(): void {
        if (this.activeModalAddon) {
            delete this.selectedAddonsMap[this.activeModalAddon.id];
        }
        this.closeAddonQtyModal();
    }

    removeAddonFromMap(addonId: string, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        delete this.selectedAddonsMap[addonId];
    }

    getSelectedAddonsList() {
        return Object.values(this.selectedAddonsMap);
    }

    calculateAddonsTotal(): number {
        return Object.values(this.selectedAddonsMap).reduce(
            (sum, item) => sum + item.totalPrice,
            0,
        );
    }

    calculateTotalPrice(): number {
        const pkg = this.getSelectedPackage();
        const pkgPrice = (pkg?.price !== undefined && pkg?.price !== null) ? Number(pkg.price) : 0;
        return pkgPrice + this.calculateAddonsTotal();
    }

    calculateFinalTotal(): number {
        return Math.max(0, this.calculateTotalPrice() - this.appliedDiscount);
    }

    // Voucher Handling
    applyVoucher(): void {
        this.voucherSuccessMsg = '';
        this.voucherErrorMsg = '';
        const code = this.voucherCode.trim().toUpperCase();

        if (!code) {
            this.voucherErrorMsg = 'Silakan masukkan kode promo / voucher.';
            return;
        }

        if (code === 'VISIDEA2026') {
            this.appliedDiscount = 50000;
            this.appliedVoucherCode = code;
            this.voucherSuccessMsg = 'Kode voucher VISIDEA2026 berhasil dipasang! (Diskon Rp50.000)';
        } else if (code === 'HEMAT10' || code === 'PROMO10') {
            const subtotal = this.calculateTotalPrice();
            this.appliedDiscount = Math.round(subtotal * 0.1);
            this.appliedVoucherCode = code;
            this.voucherSuccessMsg = `Kode voucher ${code} berhasil dipasang! (Diskon 10% - Rp${this.appliedDiscount.toLocaleString()})`;
        } else if (code === 'AWH50') {
            this.appliedDiscount = 36000;
            this.appliedVoucherCode = code;
            this.voucherSuccessMsg = 'Kode voucher AWH50 berhasil dipasang! (Diskon Rp36.000)';
        } else {
            this.voucherErrorMsg = 'Kode voucher tidak valid atau telah kedaluwarsa.';
        }
    }

    removeVoucher(): void {
        this.appliedDiscount = 0;
        this.appliedVoucherCode = '';
        this.voucherCode = '';
        this.voucherSuccessMsg = '';
        this.voucherErrorMsg = '';
    }

    setReligion(relId: string): void {
        this.selectedReligion = relId;
        const relPreset = this.getReligionPreset();
        const agamaName = relPreset?.name || relId;

        const sessionPayload = {
            religion: agamaName,
            selected_religion: agamaName,
            religion_id: relPreset?.id || relId,
            religion_label: relPreset?.label || relId,
            namaAcara: relPreset?.namaAcara || 'Akad',
            ucapanPembuka: relPreset?.ucapanPembuka || '',
            ucapanPenutup: relPreset?.ucapanPenutup || '',
            surat: relPreset?.surat || '',
            artiSurat: relPreset?.artiSurat || '',
            greeting: relPreset?.ucapanPembuka || '',
            icon: relPreset?.icon || '✨',
            updated_at: new Date().toISOString()
        };

        if (typeof window !== 'undefined') {
            try {
                // Save matching $_SESSION['agama']['name'] structure
                const agamaSession = { name: agamaName };
                if (window.sessionStorage) {
                    sessionStorage.setItem('agama', JSON.stringify(agamaSession));
                    sessionStorage.setItem('religion', agamaName);
                    sessionStorage.setItem('selected_religion', agamaName);
                    sessionStorage.setItem('visidea_invitation_religion', agamaName);
                    sessionStorage.setItem('user_session_data', JSON.stringify(sessionPayload));
                }
                if (window.localStorage) {
                    localStorage.setItem('agama', JSON.stringify(agamaSession));
                    localStorage.setItem('religion', agamaName);
                    localStorage.setItem('selected_religion', agamaName);
                    localStorage.setItem('visidea_invitation_religion', agamaName);
                    localStorage.setItem('user_session_data', JSON.stringify(sessionPayload));
                }
            } catch (e) {
                console.error('Error saving user session data:', e);
            }
        }

        if (this.selectedDemoItem) {
            this.rawDemoUrl = this.getThemeDemoUrl(this.selectedDemoItem, agamaName);
            this.demoVariants = this.getThemeDemoVariants(this.selectedDemoItem);
        }
    }

    getReligionPreset(): any {
        const active = (this.selectedReligion || 'islam').toLowerCase();
        return this.religions.find((r) =>
            r.id.toLowerCase() === active ||
            r.name.toLowerCase() === active ||
            (active.includes('kristen') && r.id.includes('kristen') && !active.includes('katolik') && !r.id.includes('katolik')) ||
            (active.includes('katolik') && r.id.includes('katolik'))
        ) || this.religions[0];
    }

    getColorSchemePreset() {
        return this.colorSchemes.find((c) => c.id === this.selectedColorScheme) || this.colorSchemes[0];
    }

    getThemeDemoVariants(theme: any): Array<{ id: string; name: string; religion?: string; icon: string; tag: string; url: string; badge?: string; color: string; isSelected?: boolean }> {
        if (!theme) return [];

        const activeRel = (this.selectedReligion || 'islam').toLowerCase();
        const baseUrl = this.getThemeDemoUrl(theme, activeRel);
        const variants: Array<{ id: string; name: string; religion?: string; icon: string; tag: string; url: string; badge?: string; color: string; isSelected?: boolean }> = [];

        // Check if rawApiData has custom defined religion links or demo_urls
        const rawApi = theme.rawApiData;
        if (rawApi?.religions && Array.isArray(rawApi.religions) && rawApi.religions.length > 0) {
            rawApi.religions.forEach((rel: any, idx: number) => {
                const relKey = (rel.key || rel.slug || `rel-${idx}`).toLowerCase();
                const isCurrent = relKey === activeRel;
                variants.push({
                    id: relKey,
                    name: rel.name || rel.title || `Versi ${rel.key}`,
                    religion: relKey,
                    icon: rel.icon || '✨',
                    tag: rel.description || rel.tag || 'Versi Khusus Agama',
                    url: this.cleanAndFormatDemoUrl(rel.url || rel.demo_url || `${baseUrl}`, relKey),
                    badge: isCurrent ? 'TERPILIH (AKTIF)' : (rel.badge || 'PILIHAN'),
                    color: rel.color || 'from-blue-600 to-indigo-700',
                    isSelected: isCurrent
                });
            });
            return variants;
        }

        // Standard religion variants dynamically built from religions array
        let cleanBase = baseUrl;
        cleanBase = cleanBase.replace(/([?&])religion=[^&]*(&|$)/, '$1').replace(/[?&]$/, '');
        const sep = cleanBase.includes('?') ? '&' : '?';

        const list = this.religions.map((rel) => {
            const isCurrent = (activeRel === rel.id.toLowerCase() || activeRel === rel.name.toLowerCase());

            let description = 'Format ucapan & doa khusus';
            if (rel.id === 'islam') description = 'Format ucapan Akad & doa QS. Ar-Rum Ayat 21';
            else if (rel.id.includes('protestan') || rel.id === 'kristen') description = 'Pemberkatan Pernikahan & 1 Korintus 13:13';
            else if (rel.id.includes('katolik')) description = 'Sakramen Pernikahan & Injil Matius 19:6';
            else if (rel.id === 'hindu') description = 'Upacara Pawiwahan & doa Artharvaveda';
            else if (rel.id === 'buddha') description = 'Pemberkatan Pernikahan & Angutara Nikaya';
            else if (rel.id === 'konghucu') description = 'Upacara Hunli & doa Kitab Mengzi';
            else if (rel.id === 'general') description = 'Format resepsi nasional tanpa atribut keagamaan khusus';

            return {
                id: rel.id,
                name: rel.label,
                religion: rel.name || rel.id,
                icon: rel.icon,
                tag: description,
                url: `${cleanBase}${sep}religion=${encodeURIComponent(rel.name || rel.id)}`,
                badge: isCurrent ? 'TERPILIH' : '',
                color: '',
                isSelected: isCurrent
            };
        });

        return list;
    }

    openDemoModal(theme: any): void {
        if (theme.isCustomEvent || theme.alias === 'custom-event-invitation') {
            this.openCustomEventModal();
            return;
        }
        this.selectedDemoItem = theme;
        const themeCat = String(theme.category || '').toLowerCase();

        // For event / acara themes (e.g. Birthday, Grand Opening), open demo directly in new tab
        if (themeCat.includes('event') || themeCat.includes('acara') || themeCat.includes('guest')) {
            const targetUrl = theme.demo_url || theme.demoUrl || this.getThemeDemoUrl(theme);
            if (targetUrl && typeof window !== 'undefined') {
                window.open(targetUrl, '_blank');
            }
            return;
        }

        this.isDemoIframeLoading = true;
        const activeRel = this.selectedReligion || 'islam';
        const targetUrl = this.getThemeDemoUrl(theme, activeRel);
        this.rawDemoUrl = targetUrl;
        this.demoVariants = this.getThemeDemoVariants(theme);

        const iframeUrl = this.getIframeDemoUrl(targetUrl);
        this.safeDemoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
        this.demoViewMode = 'interactive';
        this.isDemoModalOpen = true;

        // Generate QR code for mobile scanning
        if (targetUrl) {
            QRCode.toDataURL(targetUrl, {
                width: 180,
                margin: 1,
                color: {
                    dark: '#102B51',
                    light: '#ffffff',
                },
            }).then((dataUrl) => {
                this.demoQrCodeUrl = dataUrl;
            }).catch((err) => {
                console.error('Error generating demo QR code:', err);
            });
        }
    }

    selectAgama(id: string): void {
        this.selectedReligion = id;
        this.setReligion(id);
    }

    async confirmAgamaAndOpenDemo(): Promise<void> {
        console.log('confirmAgamaAndOpenDemo called');
        console.log('selectedReligion:', this.selectedReligion);
        console.log('selectedDemoItem:', this.selectedDemoItem);
        console.log('rawDemoUrl before:', this.rawDemoUrl);
        
        if (!this.selectedReligion) {
            this.selectedReligion = 'islam';
        }
        const targetAgama = this.selectedReligion;

        try {
            const formData = new FormData();
            formData.append('agama', targetAgama);
            fetch(`https://invitation.visideastudio.com/save-agama/${encodeURIComponent(targetAgama)}`, {
                method: 'POST',
                mode: 'no-cors',
                body: formData
            }).catch(() => { });
        } catch (e) { }

        const activeRel = targetAgama;
        const targetUrl = this.selectedDemoItem ? this.getThemeDemoUrl(this.selectedDemoItem, activeRel) : this.rawDemoUrl;
        
        console.log('targetUrl generated:', targetUrl);

        if (targetUrl && typeof window !== 'undefined') {
            // Store the URL for fallback button
            this.rawDemoUrl = targetUrl;
            
            // Close the religion selection modal
            this.closeDemoModal();
            
            // Open in popup window sized like smartphone (380x820)
            const width = 400;
            const height = 850;
            const left = (screen.width - width) / 2;
            const top = Math.max(50, (screen.height - height) / 2);
            
            // Enhanced features to force popup window (not tab)
            const features = [
                `width=${width}`,
                `height=${height}`,
                `left=${left}`,
                `top=${top}`,
                'resizable=yes',
                'scrollbars=yes',
                'toolbar=no',
                'menubar=no',
                'location=no',
                'directories=no',
                'status=no',
                'copyhistory=no',
                'popup=yes'
            ].join(',');
            
            const windowName = 'DemoUndangan_' + Date.now(); // Unique name
            const popup = window.open(targetUrl, windowName, features);
            
            if (popup) {
                popup.focus();
                console.log('Popup window opened successfully');
            } else {
                console.error('Popup blocked by browser');
                // Fallback: open in new tab if popup is blocked
                window.open(targetUrl, '_blank');
            }
        } else {
            console.error('No target URL found!');
            this.closeDemoModal();
        }
    }

    selectDemoVariant(variant: any): void {
        if (variant?.religion) {
            this.selectAgama(variant.religion);
        }
        const urlToOpen = variant?.url || this.rawDemoUrl;
        if (urlToOpen) {
            // Open in fullscreen iframe modal (consistent with main demo button)
            this.fullscreenDemoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlToOpen);
            this.isFullscreenDemoLoading = true;
            this.isFullscreenDemoOpen = true;
        }
        this.closeDemoModal();
    }

    openDirectDemo(theme?: any, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.confirmAgamaAndOpenDemo();
    }

    closeDemoModal(): void {
        this.isDemoModalOpen = false;
        this.selectedDemoItem = null;
        this.safeDemoUrl = null;
        this.rawDemoUrl = '';
        this.demoQrCodeUrl = '';
        this.isDemoIframeLoading = false;
        this.demoVariants = [];
    }

    closeFullscreenDemo(): void {
        this.isFullscreenDemoOpen = false;
        this.fullscreenDemoUrl = null;
        this.isFullscreenDemoLoading = false;
        this.demoModalPosition = { x: 0, y: 0 };
        this.isDragging = false;
    }

    openDemoInNewTabFromFullscreen(): void {
        // Get the raw URL from the current demo
        const rawUrl = this.rawDemoUrl || (this.selectedDemoItem ? this.getThemeDemoUrl(this.selectedDemoItem, this.selectedReligion) : '');
        
        if (rawUrl && typeof window !== 'undefined') {
            window.open(rawUrl, '_blank');
        }
        
        // Optionally close the fullscreen modal after opening new tab
        // this.closeFullscreenDemo();
    }

    onFullscreenDemoLoad(): void {
        console.log('Iframe load event fired');
        this.isFullscreenDemoLoading = false;
    }

    onFullscreenDemoError(): void {
        console.error('Iframe error event fired');
        this.isFullscreenDemoLoading = false;
    }

    startDrag(event: MouseEvent): void {
        this.isDragging = true;
        this.dragStartPos = {
            x: event.clientX - this.demoModalPosition.x,
            y: event.clientY - this.demoModalPosition.y
        };
        event.preventDefault();
    }

    onDrag(event: MouseEvent): void {
        if (this.isDragging) {
            this.demoModalPosition = {
                x: event.clientX - this.dragStartPos.x,
                y: event.clientY - this.dragStartPos.y
            };
        }
    }

    stopDrag(): void {
        this.isDragging = false;
    }

    getIframeDemoUrl(absoluteUrl: string): string {
        return absoluteUrl || '';
    }

    cleanAndFormatDemoUrl(raw: any, religionKey?: string): string {
        if (!raw || typeof raw !== 'string') return '';
        let url = raw.trim();

        // If there is any nested URL prefix (e.g. "https://undangan.visideastudio.com/https://invitation.visideastudio.com/...")
        const httpsLastIdx = url.lastIndexOf('https://');
        const httpLastIdx = url.lastIndexOf('http://');
        const lastIdx = Math.max(httpsLastIdx, httpLastIdx);
        if (lastIdx > 0) {
            url = url.substring(lastIdx);
        }

        const activeRel = (religionKey || this.selectedReligion || 'islam').toLowerCase();

        // If it's already an absolute URL (e.g. "https://invitation.visideastudio.com/...")
        if (url.startsWith('http://') || url.startsWith('https://')) {
            if (activeRel) {
                if (url.includes('religion=')) {
                    url = url.replace(/([?&])religion=[^&]*/, `$1religion=${activeRel}`);
                } else {
                    const sep = url.includes('?') ? '&' : '?';
                    url = `${url}${sep}religion=${activeRel}`;
                }
            }
            return url;
        }

        // Clean leading slashes
        url = url.replace(/^\/+/, '');

        // Construct standard Visidea invitation domain with default parameter and active religion
        return `https://invitation.visideastudio.com/${url}?to=Johan%20Susanto&religion=${activeRel}`;
    }

    getThemeDemoUrl(theme: any, religionKey?: string): string {
        if (!theme) return '';

        const activeRel = (religionKey || this.selectedReligion || 'islam').toLowerCase();

        // 1. Check if rawApiData has custom defined religion links
        const rawApi = theme.rawApiData || theme;
        if (rawApi?.religions && Array.isArray(rawApi.religions)) {
            const matchedRel = rawApi.religions.find((r: any) =>
                (r.key && r.key.toLowerCase() === activeRel) ||
                (r.slug && r.slug.toLowerCase() === activeRel) ||
                (r.id && r.id.toLowerCase() === activeRel) ||
                (r.name && r.name.toLowerCase().includes(activeRel))
            );
            if (matchedRel && (matchedRel.url || matchedRel.demo_url || matchedRel.link)) {
                return this.cleanAndFormatDemoUrl(matchedRel.url || matchedRel.demo_url || matchedRel.link, activeRel);
            }
        }

        if (rawApi?.religion_links && typeof rawApi.religion_links === 'object' && rawApi.religion_links[activeRel]) {
            return this.cleanAndFormatDemoUrl(rawApi.religion_links[activeRel], activeRel);
        }

        if (rawApi?.demo_urls && typeof rawApi.demo_urls === 'object' && rawApi.demo_urls[activeRel]) {
            return this.cleanAndFormatDemoUrl(rawApi.demo_urls[activeRel], activeRel);
        }

        const candidates = [
            theme.demo_url,
            theme.demoUrl,
            theme.url,
            theme.preview_url,
            theme.link,
            theme.website_url,
            theme.preview_link,
            theme.rawApiData?.demo_url,
            theme.rawApiData?.url,
            theme.rawApiData?.preview_url,
            theme.rawApiData?.link,
            theme.rawApiData?.website_url,
            theme.rawApiData?.preview_link,
            theme.rawApiData?.slug,
            theme.rawApiData?.alias,
            theme.slug,
            theme.alias,
        ];

        for (const cand of candidates) {
            if (cand && typeof cand === 'string' && cand.trim().length > 0) {
                const formatted = this.cleanAndFormatDemoUrl(cand, activeRel);
                if (formatted) return formatted;
            }
        }

        const fallbackSlug = theme.alias || theme.rawApiData?.slug || 'wedding-of-let-the-adventure-begin';
        return `https://invitation.visideastudio.com/${fallbackSlug}?to=Johan%20Susanto&religion=${activeRel}`;
    }

    onDemoIframeLoaded(): void {
        this.isDemoIframeLoading = false;
    }

    reloadDemoIframe(): void {
        if (!this.selectedDemoItem) return;
        this.isDemoIframeLoading = true;
        const currentUrl = this.getIframeDemoUrl(this.rawDemoUrl);
        this.safeDemoUrl = null;
        setTimeout(() => {
            this.safeDemoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(currentUrl);
        }, 100);
    }
}

